/* Italiano — Italian */
const it = {
  nav: {
    home: 'Home',
    imageConverter: 'Converti Immagine',
    imageCompressor: 'Comprimi Immagine',
    otherTools: 'Altri Strumenti',
    resizeImage: 'Ridimensiona Immagine',
    cropImage: 'Ritaglia Immagine',
    photoEditor: 'Editor Foto',
    removeBackground: 'Rimuovi Sfondo',
    watermarkImage: 'Filigrana Immagine',
    qrCodeGenerator: 'Generatore QR Code',
    qrCodeScanner: 'Scanner QR Code',
    aboutUs: 'Chi Siamo',
    faceBlur: 'Sfoca Volti',
  },

  hero: {
    heading: 'Tutti gli Strumenti per le Tue Immagini',
    subheading: 'Strumenti online gratuiti per convertire, comprimere, ridimensionare, ritagliare, modificare e trasformare le tue immagini. Tutto nel tuo browser — veloce, privato e sicuro.',
  },

  tools: {
    compressImage: { title: 'COMPRIMI IMMAGINE', desc: 'Comprimi JPG, PNG, SVG e GIF risparmiando spazio e mantenendo la qualità.' },
    resizeImage: { title: 'RIDIMENSIONA IMMAGINE', desc: 'Definisci le dimensioni in percentuale o pixel e ridimensiona JPG, PNG, SVG e GIF.' },
    cropImage: { title: 'RITAGLIA IMMAGINE', desc: 'Ritaglia JPG, PNG o GIF facilmente; scegli i pixel o usa il nostro editor visuale.' },
    convertToJpg: { title: 'Converti in JPG', desc: 'Converti PNG, GIF, TIF, PSD, SVG, WEBP, HEIC o RAW in JPG in blocco.' },
    convertFromJpg: { title: 'Converti da JPG', desc: 'Converti JPG in PNG e GIF. Scegli più JPG per creare una GIF animata in secondi!' },
    qrCodeGenerator: { title: 'Generatore QR Code', desc: 'Genera QR code personalizzati per URL, testo, WiFi, contatti, email e mappe.' },
    qrCodeScanner: { title: 'Scanner QR Code', desc: 'Scansiona QR code con la fotocamera o caricando un\'immagine. Rileva URL, testo, WiFi e altro.' },
    blurFace: { title: 'Sfoca Volti', desc: 'Rileva e sfoca automaticamente i volti nelle immagini per la privacy.' },
    removeBackground: { title: 'Rimuovi Sfondo', desc: 'Rimuovi rapidamente gli sfondi con alta precisione.' },
    watermarkImage: { title: 'FILIGRANA IMMAGINE', desc: 'Aggiungi un\'immagine o testo alle tue foto in secondi.' },
  },

  whyChoose: {
    label: 'Perché Sceglierci',
    heading: 'Il Modo Intelligente di Modificare le Immagini',
    subheading: 'Scelto da migliaia di creatori, designer e sviluppatori in tutto il mondo.',
    reasons: {
      fast: { title: 'Velocità Fulminea', desc: 'Tutto viene elaborato nel tuo browser. Nessun caricamento su server esterni.' },
      private: { title: '100% Privato e Sicuro', desc: 'I tuoi file non lasciano mai il tuo dispositivo. Non memorizziamo né condividiamo le tue immagini.' },
      noLimits: { title: 'Nessun Limite, Nessuna Registrazione', desc: 'Usa ogni strumento quante volte vuoi — completamente gratuito.' },
      quality: { title: 'Qualità Professionale', desc: 'I nostri algoritmi forniscono risultati di livello professionale.' },
      batch: { title: 'Elaborazione in Blocco', desc: 'Gestisci più file contemporaneamente.' },
      everywhere: { title: 'Funziona Ovunque', desc: 'Design responsive su desktop, tablet e mobile.' },
    },
    stats: {
      imagesProcessed: 'Immagini Elaborate',
      countriesServed: 'Paesi Serviti',
      uptime: 'Disponibilità',
      freeTools: 'Strumenti Gratuiti',
    },
  },

  footer: {
    tagline: 'Strumenti online gratuiti per immagini — converti, comprimi, ridimensiona, ritaglia e modifica in secondi. Nessuna registrazione richiesta.',
    imageTools: 'Strumenti Immagine',
    moreTools: 'Altri Strumenti',
    company: 'Azienda',
    contact: 'Contatti',
    allRightsReserved: 'Tutti i diritti riservati.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Termini di Servizio',
  },

  faq: {
    badge: 'FAQ',
    heading: 'Domande Frequenti',
    subheading: 'Risposte rapide alle domande più comuni su questo strumento.',
    stillHaveQuestions: 'Hai ancora domande? Siamo qui per aiutarti!',
    reachOut: 'Contatta il Nostro Team',
    questionHeader: 'Domanda',
  },

  contactForm: {
    badge: 'Contattaci',
    title: 'Contattaci',
    subtitle: 'Ci farebbe piacere sentirti. Mandaci un messaggio!',
    nameLabel: 'Nome',
    namePlaceholder: 'Il tuo nome completo',
    emailLabel: 'Email',
    emailPlaceholder: 'tu@email.it',
    subjectLabel: 'Oggetto',
    subjectPlaceholder: 'Di cosa si tratta?',
    messageLabel: 'Messaggio',
    messagePlaceholder: 'Scrivi qui il tuo messaggio…',
    errName: 'Il nome è obbligatorio',
    errEmail: "L'email è obbligatoria",
    errEmailInvalid: 'Inserisci un\'email valida',
    errSubject: "L'oggetto è obbligatorio",
    errMessage: 'Il messaggio è obbligatorio',
    sending: 'Invio in corso…',
    send: 'Invia Messaggio',
    successTitle: 'Messaggio Inviato!',
    successMsg: 'Grazie per averci contattato. Ti risponderemo presto.',
    sendAnother: 'Invia un Altro',
    sendError: 'Qualcosa è andato storto. Riprova.',
  },

  about: {
    label: 'Chi Siamo',
    heading: 'Creato per Creatori, da Creatori',
    subheading: 'Crediamo che gli strumenti potenti per le immagini debbano essere gratuiti, veloci e accessibili a tutti.',
    missionTitle: 'La Nostra Missione',
    missionText: 'photremium.com è stato creato con un obiettivo semplice: offrire l\'esperienza di editing delle immagini più intuitiva, veloce e privata sul web.',
    privacyTitle: 'Privacy Prima di Tutto',
    privacyText: 'Non carichiamo, archiviamo né elaboriamo le tue immagini su server remoti. Tutto rimane sul tuo dispositivo.',
    techTitle: 'Tecnologia Moderna',
    techText: 'Realizzato con tecnologie web all\'avanguardia tra cui WebAssembly, Canvas API e React moderno.',
    communityTitle: 'Guidato dalla Community',
    communityText: 'Ogni funzionalità che creiamo è ispirata dai feedback degli utenti reali.',
    globalTitle: 'Portata Globale',
    globalText: 'Usato da creatori in oltre 120 paesi.',
  },

  seo: {
    homeTitle: 'photremium.com — Convertitore, Compressore ed Editor di Immagini Online Gratuito',
    homeDesc: 'Converti, comprimi, ridimensiona, ritaglia e modifica immagini online gratuitamente. Veloce, privato e sicuro.',
    homeKeywords: 'convertitore immagini, compressore immagini, ridimensiona immagine, ritaglia immagine, editor foto, strumenti immagine online',
    aboutTitle: 'Chi Siamo — photremium.com: La Nostra Missione',
    aboutDesc: 'Scopri photremium.com, il kit di strumenti per immagini online gratuito. La nostra missione è rendere il fotoritocco professionale accessibile a tutti.',
    aboutKeywords: 'chi siamo photremium.com, strumenti immagine, editor immagini gratuito',
  },

        privacyPolicyPage: {
    seo: {
      title: 'Informativa sulla privacy — Fotremio | Nessun caricamento sul server, zero archiviazione di dati',
      description: 'L\'Informativa sulla privacy di Photremium spiega come proteggiamo la tua privacy. Tutta l\'elaborazione delle immagini avviene al 100% nel tuo browser: nessun caricamento di file su nessun server, nessun dato personale raccolto, nessun tracciamento.',
      ogTitle: 'Informativa sulla privacy — Fotremio | Nessun caricamento, zero spazio di archiviazione',
      ogDescription: 'I tuoi file rimangono sul tuo dispositivo. Photremium elabora tutte le immagini localmente nel tuo browser senza contatto con il server, senza dati archiviati e senza tracciamento.',
      twitterTitle: 'Informativa sulla privacy – Fotremio',
      twitterDescription: 'Strumenti di immagine basati al 100% su browser. Nessun caricamento, nessuno spazio di archiviazione, nessun tracciamento. Leggi la nostra politica sulla privacy completa.',
      schemaName: 'Informativa sulla privacy - Fotremio',
      schemaDescription: 'Informativa sulla privacy di Photremium: nessun caricamento sul server, nessun dato archiviato, elaborazione delle immagini nel browser al 100%.'
    },
    hero: {
      badge: 'politica sulla riservatezza',
      titlePrefix: 'La tua privacy è nostra',
      titleHighlight: 'Massima priorità',
      subPrefix: 'photremium.com si basa su un principio semplice:',
      subStrong: 'i tuoi file non lasciano mai il tuo dispositivo',
      subSuffix: 'Ogni strumento per le immagini su questo sito viene eseguito interamente all\'interno del tuo browser. Nessun caricamento. Nessuna nuvola. Nessun compromesso.',
      effectiveLabel: 'Efficace',
      lastUpdatedLabel: 'Ultimo aggiornamento',
      worldwideLabel: 'Si applica in tutto il mondo'
    },
    trustCards: [
      {
        title: 'Nessun caricamento sul server',
        desc: 'I tuoi file non lasciano mai il tuo dispositivo. Tutta l\'elaborazione avviene al 100% nel browser.'
      },
      {
        title: 'Zero archiviazione dei dati',
        desc: 'Non memorizziamo nulla su di te, sulle tue immagini o sulla tua attività.'
      },
      {
        title: 'Nessun tracciamento',
        desc: 'Nessun tracciamento comportamentale, nessuna impronta digitale, nessuna profilazione.'
      },
      {
        title: 'Rispettoso del GDPR',
        desc: 'Progettato da zero per rispettare le normative globali sulla privacy.'
      }
    ],
    contentsTitle: 'Contenuto',
    toc: {
      overview: 'Panoramica',
      'no-upload': 'Nessuna elaborazione del server',
      'data-collect': 'Dati che raccogliamo',
      cookies: 'Cookie e archiviazione',
      'third-party': 'Servizi di terze parti',
      analytics: 'Analitica',
      children: 'Privacy dei bambini',
      rights: 'I tuoi diritti',
      security: 'Sicurezza',
      changes: 'Modifiche alle politiche',
      contact: 'Contattaci'
    },
    sections: {
      overview: {
        title: '1. Panoramica',
        subtitle: 'Cosa copre questa polizza',
        p1Prefix: 'La presente Informativa sulla privacy descrive come',
        p1Middle: '("noi", "ci" o "nostro") gestisce - o più precisamente,',
        p1Italic: 'non gestisce',
        p1Suffix: 'le tue informazioni personali quando utilizzi i nostri strumenti di immagine online gratuiti su',
        p2: 'A differenza delle applicazioni web tradizionali che inviano file a server remoti per l\'elaborazione, photremium.com utilizza le moderne API del browser (API Canvas, WebAssembly, WebWorkers) per eseguire ogni operazione localmente sul tuo dispositivo. Il risultato: nessuna trasmissione di dati, nessuna memorizzazione, nessun rischio.',
        calloutLabel: 'Riepilogo in inglese semplice:',
        calloutText: 'Non possiamo vedere le tue immagini, non vogliamo e la nostra tecnologia è appositamente progettata in modo che non potremmo mai vederla.'
      },
      noUpload: {
        title: '2. Nessuna elaborazione del server: mai',
        subtitle: 'Come funzionano effettivamente i nostri strumenti',
        introPrefix: 'Tutti gli strumenti su photremium.com (convertitore di immagini, compressore, ridimensionatore, rimozione sfondo, sfocatura viso, filigrana, ritaglio e strumenti per codici QR) elaborano i tuoi file',
        introStrong: '100% all\'interno del tuo browser web',
        introSuffix: 'utilizzando JavaScript lato client e WebAssembly.',
        points: [
          {
            label: 'Non avviene mai il caricamento di file.',
            text: 'Quando selezioni un file, questo viene letto dall\'API File del tuo browser ed elaborato in memoria: non viene mai inviato in rete.'
          },
          {
            label: 'Nessun server riceve la tua immagine.',
            text: 'La nostra CDN fornisce solo le risorse HTML, CSS e JavaScript necessarie per eseguire l\'app, non i tuoi file.'
          },
          {
            label: 'Nessun deposito temporaneo.',
            text: 'I risultati elaborati esistono solo nella memoria del tuo browser e vengono rilasciati quando chiudi o esci dalla pagina.'
          },
          {
            label: 'Funziona offline.',
            text: 'La maggior parte degli strumenti continua a funzionare senza una connessione Internet dopo il caricamento iniziale della pagina: un\'ulteriore prova che non è coinvolto alcun server.'
          }
        ],
        callout: 'Puoi verificarlo tu stesso: apri la scheda Rete del browser in Strumenti per sviluppatori, seleziona un\'immagine e conferma che nessun dato di file viene trasmesso a nessun server esterno.'
      },
      dataCollect: {
        title: '3. Dati che raccogliamo (e non raccogliamo)',
        subtitle: 'Piena trasparenza sulle pratiche relative ai dati',
        headers: {
          type: 'Tipo di dati',
          collected: 'Raccolto?',
          whereWhy: 'Dove/Perché'
        },
        rows: [
          {
            type: 'Le tue immagini/file',
            badge: 'Mai',
            variant: 'verde',
            showX: true,
            whereWhy: 'Elaborato interamente nel tuo browser, mai trasmesso'
          },
          {
            type: 'Nome/indirizzo e-mail',
            badge: 'Mai',
            variant: 'verde',
            showX: true,
            whereWhy: 'Non è richiesto alcun account o registrazione per utilizzare alcuno strumento'
          },
          {
            type: 'Indirizzo IP',
            badge: 'Minimo',
            variant: 'grigio',
            showX: false,
            whereWhy: 'Registri del server Web standard conservati <= 30 giorni, non legati all\'identità'
          },
          {
            type: 'Tipo di browser/sistema operativo',
            badge: 'Minimo',
            variant: 'grigio',
            showX: false,
            whereWhy: 'Inviato automaticamente dal tuo browser; usato solo per compatibilità'
          },
          {
            type: 'Pagine visitate/clic',
            badge: 'Aggregato',
            variant: 'blu',
            showX: false,
            whereWhy: 'Solo analisi anonime (nessuna identificazione personale)'
          },
          {
            type: 'Preferenza della lingua',
            badge: 'Solo locale',
            variant: 'blu',
            showX: false,
            whereWhy: 'Salvato in localStorage sul tuo dispositivo e mai inviato a noi'
          },
          {
            type: 'Pagamento/dati finanziari',
            badge: 'Mai',
            variant: 'verde',
            showX: true,
            whereWhy: 'photremium.com è completamente gratuito e non sono richiesti pagamenti'
          }
        ]
      },
      cookies: {
        title: '4. Cookie e archiviazione locale',
        subtitle: 'Cosa viene memorizzato sul tuo dispositivo',
        intro: 'photremium.com non utilizza cookie pubblicitari, cookie di tracciamento tra siti e cookie di terze parti. L\'unico spazio di archiviazione del browser che utilizziamo è per le funzionalità essenziali del sito.',
        points: [
          {
            label: 'Preferenza della lingua',
            text: 'Memorizzato in localStorage in modo che il sito ricordi la tua lingua preferita tra una visita e l\'altra. Mai inviato ai nostri server.'
          },
          {
            label: 'Preferenze tema/interfaccia utente',
            text: 'Se imposti una preferenza di visualizzazione, questa verrà salvata localmente solo sul tuo dispositivo.'
          },
          {
            label: 'Nessun cookie di sessione.',
            text: 'photremium.com non dispone di un sistema di accesso, quindi non vengono mai scritti cookie ID di sessione.'
          }
        ],
        callout: 'Puoi cancellare tutta la memoria locale di photremium.com in qualsiasi momento tramite le impostazioni del browser (Impostazioni -> Privacy -> Cancella dati di navigazione -> Dati e cookie memorizzati nella cache). Ciò non ha alcun effetto sulla tua capacità di utilizzare gli strumenti.'
      },
      thirdParty: {
        title: '5. Servizi di terze parti',
        subtitle: 'Servizi esterni che utilizziamo e perché',
        intro: 'photremium.com utilizza un insieme minimo di servizi di terze parti affidabili esclusivamente per l\'infrastruttura e le prestazioni. Nessuno di questi servizi riceve le tue immagini o informazioni di identificazione personale.',
        headers: {
          service: 'Servizio',
          purpose: 'Scopo',
          dataShared: 'Dati condivisi',
          privacyPolicy: 'politica sulla riservatezza'
        },
        rows: [
          {
            service: 'Pagine di Cloudflare',
            purpose: 'Hosting e consegna CDN delle risorse del sito',
            dataShared: 'Indirizzo IP, intestazioni HTTP (standard)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Carattere fantastico',
            purpose: 'Caratteri delle icone caricati dalla CDN',
            dataShared: 'Indirizzo IP (solo richiesta CSS)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google Fonts',
            purpose: 'Caricamento del carattere tipografico (se applicabile)',
            dataShared: 'Indirizzo IP (solo richiesta carattere)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Non condividiamo i tuoi dati con inserzionisti, intermediari di dati o altre terze parti oltre ai fornitori di infrastrutture sopra elencati.'
      },
      analytics: {
        title: '6. Analitica',
        subtitle: 'Dati di utilizzo aggregati e rispettosi della privacy',
        introPrefix: 'Per capire quali strumenti sono popolari e come migliorare il sito, potremmo raccogliere',
        introStrong: 'aggregato, anonimizzato',
        introSuffix: 'statistiche di utilizzo come:',
        points: [
          'Numero di pagine visualizzate per strumento (nessuna identificazione dell\'utente)',
          'Fonte di riferimento (ad esempio ricerca Google, collegamento diretto) – nessun dato personale',
          'Dati geografici a livello di paese (non città o posizione precisa)',
          'Tipo di browser/dispositivo per l\'analisi della compatibilità'
        ],
        calloutLabel: 'Nessun dato è collegato a te personalmente.',
        calloutText: 'Non utilizziamo Google Analytics o Meta Pixel. Qualsiasi analisi che utilizziamo è uno strumento che mette al primo posto la privacy (ad esempio Plausible o simili).'
      },
      children: {
        title: '7. Privacy dei bambini',
        subtitle: 'COPPA e conformità alla sicurezza dei bambini',
        p1: 'photremium.com non raccoglie consapevolmente alcuna informazione personale da bambini di età inferiore a 13 anni (o 16 nell\'Unione Europea ai sensi del GDPR). Poiché non raccogliamo dati personali di nessun utente, non c\'è niente di speciale da fare per gli utenti più giovani: il sito è ugualmente sicuro per tutti.',
        p2Prefix: 'Se ritieni che un bambino abbia in qualche modo inviato informazioni personali tramite il nostro modulo di contatto, contattaci immediatamente all\'indirizzo',
        p2Suffix: 'e lo elimineremo tempestivamente.'
      },
      rights: {
        title: '8. I tuoi diritti',
        subtitle: 'GDPR, CCPA e diritti globali sulla privacy',
        intro: 'Poiché photremium.com non raccoglie informazioni di identificazione personale, la maggior parte dei diritti dell\'interessato si applicano banalmente: non ci sono dati su di te a cui accedere, correggere o eliminare. Tuttavia, riconosciamo e rispettiamo pienamente i seguenti diritti:',
        points: [
          {
            label: 'Diritto di accesso',
            text: 'Puoi richiedere una copia di tutti i dati che conserviamo su di te. (Non ce n\'è altro oltre ai registri anonimi.)'
          },
          {
            label: 'Diritto alla correzione',
            text: 'È possibile richiedere la correzione di dati personali inesatti.'
          },
          {
            label: 'Diritto alla cancellazione ("Diritto all\'oblio")',
            text: 'Puoi richiedere la cancellazione di tutti i dati personali in nostro possesso (GDPR Art. 17, CCPA).'
          },
          {
            label: 'Diritto di opposizione/opt-out',
            text: 'Puoi disattivare qualsiasi futura raccolta di analisi utilizzando uno strumento di disattivazione a livello di browser o di blocco degli annunci.'
          },
          {
            label: 'Diritto alla portabilità dei dati',
            text: 'Tutto il tuo lavoro viene scaricato direttamente sul tuo dispositivo: non è necessaria alcuna richiesta di esportazione.'
          }
        ],
        callout: 'Questi diritti si applicano a tutti gli utenti in tutto il mondo, indipendentemente dalla giurisdizione: applichiamo lo standard più elevato (GDPR) come base di riferimento.'
      },
      security: {
        title: '9. Sicurezza',
        subtitle: 'Come proteggiamo la tua esperienza',
        intro: 'I dati più sicuri sono quelli che non vengono mai raccolti. L\'architettura lato client di photremium.com significa che una violazione del server non può esporre i tuoi file perché i tuoi file non sono mai sui nostri server. Ulteriori misure di sicurezza includono:',
        points: [
          {
            label: 'Applicazione HTTPS',
            text: 'Tutto il traffico tra il tuo browser e il nostro CDN è crittografato tramite TLS 1.2+ con HSTS.'
          },
          {
            label: 'Politica di sicurezza dei contenuti (CSP)',
            text: 'Intestazioni rigorose impediscono lo scripting cross-site e l\'inserimento di script inline.'
          },
          {
            label: 'Controlli regolari delle dipendenze',
            text: 'Controlliamo e aggiorniamo regolarmente i pacchetti npm per correggere le vulnerabilità note.'
          }
        ],
        disclosurePrefix: 'Divulgazione responsabile',
        disclosureTextPrefix: 'Hai riscontrato un problema di sicurezza? Inviaci un\'e-mail a',
        disclosureTextSuffix: 'e risponderemo entro 48 ore.'
      },
      changes: {
        title: '10. Modifiche a questa politica',
        subtitle: 'Come gestiamo gli aggiornamenti delle politiche',
        intro: 'Potremmo aggiornare la presente Informativa sulla privacy di tanto in tanto per riflettere i cambiamenti nelle nostre pratiche, strumenti o requisiti legali. Quando facciamo:',
        points: [
          {
            label: '"Ultimo aggiornamento"',
            text: 'la data nella parte superiore di questa pagina verrà modificata.'
          },
          {
            label: 'Cambiamenti materiali',
            text: 'sarà comunicato mediante avviso ben visibile in home page per almeno 30 giorni.'
          },
          {
            label: 'Versioni precedenti',
            text: 'di questa politica sarà archiviata e disponibile su richiesta.'
          }
        ],
        outro: 'L\'uso continuato di photremium.com dopo la pubblicazione delle modifiche costituisce l\'accettazione della politica aggiornata. Ti invitiamo a rivedere periodicamente questa pagina.'
      },
      contact: {
        title: '11. Richieste di contatto e dati',
        subtitle: 'Contattaci per la privacy',
        p1Prefix: 'Per qualsiasi domanda, dubbio o richiesta formale di dati relativa alla presente Informativa sulla privacy, contattaci. Il nostro obiettivo è rispondere a tutte le domande relative alla privacy all\'interno di',
        p1Strong: '5 giorni lavorativi'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Domande sulla privacy?',
      privacyQuestionsDesc: 'Inviaci le tue domande sulla privacy, richieste di dati o dubbi e ti risponderemo tempestivamente.',
      versionHistoryTitle: 'Cronologia delle versioni',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: 'Nuovo!',
    download: 'Scarica',
    downloadAll: 'Scarica Tutti',
    downloadAs: 'Scarica come:',
    zip: 'ZIP',
    separate: 'Separato',
    upload: 'Carica',
    dragDrop: 'Trascina e rilascia le immagini qui, o clicca per sfogliare',
    remove: 'Rimuovi',
    reset: 'Reimposta',
    apply: 'Applica',
    cancel: 'Annulla',
    clear: 'Cancella',
    close: 'Chiudi',
    save: 'Salva',
    processing: 'Elaborazione in corso...',
    noFiles: 'Nessun file selezionato',
    selectFiles: 'Seleziona file',
    or: 'o',
    browseFiles: 'sfoglia i file',
    dropHere: 'Rilascia le immagini qui',
    chooseFiles: 'Scegli File',
    pasteHint: 'Puoi anche incollare immagini con',
    quality: 'Qualità',
    width: 'Larghezza',
    height: 'Altezza',
    format: 'Formato',
    compression: 'Compressione',
    preview: 'Anteprima',
    original: 'Originale',
    result: 'Risultato',
    before: 'Prima',
    after: 'Dopo',
    startOver: 'Ricomincia',
    startOverConfirm: 'Sei sicuro di voler rimuovere tutte le immagini e ricominciare?',
    addMoreImages: 'Aggiungi Altre Immagini',
    addImage: 'Aggiungi Immagine',
    images: 'Immagini',
    totalSize: 'Dimensione Totale',
    size: 'Dimensione',
    type: 'Tipo',
    unsavedEdits: 'Hai modifiche non salvate. Lasciare questa pagina?',
    compareSlider: 'Comparatore',
    toggleToolsPanel: 'Mostra/Nascondi pannello strumenti',
    closePanel: 'Chiudi pannello',
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
    fit: 'Adatta',
    none: 'Nessuno',
  },

  compressor: {
    seo: {
      uploadTitle: 'Compressore Immagini — Comprimi JPG, PNG, SVG, GIF Online Gratis | photremium.com',
      uploadDesc: 'Comprimi JPG, PNG, SVG e GIF online gratuitamente. Riduci le dimensioni fino all\'80% mantenendo la qualità visiva.',
      uploadKeywords: 'compressore immagini, comprimi jpg, comprimi png, riduci dimensioni immagine',
      workspaceTitle: 'Compressione in Corso — photremium.com Compressore Immagini',
      workspaceDesc: 'Regola il livello di compressione e scarica le immagini ottimizzate.',
      workspaceKeywords: 'comprimi immagini, compressione immagini, ottimizzazione immagini',
    },
    title: 'Compressore Immagini',
    desc: 'Comprimi JPG, PNG e GIF fino all\'80% di riduzione. Veloce e privato — tutto nel tuo browser.',
    toCompress: 'per comprimere',
    compressionForAll: 'Compressione per tutte le immagini',
    summary: 'Riepilogo',
    originalSize: 'Dimensione Originale',
    compressed: 'Compressa',
    saved: 'Risparmiato',
    compressionLabel: 'Compressione:',
    compressing: 'Compressione in corso…',
    compressDownload: 'Comprimi e Scarica',
    lowQualityWarning: 'Una compressione elevata può ridurre sensibilmente la nitidezza dell’immagine.',
    blog: {
      tocTitle: 'Contenuti',
      title: 'Blog del Compressore Immagini',
      formatsIntro: 'Il nostro strumento supporta tutti i formati immagine, quindi puoi comprimere qualsiasi immagine senza problemi. L’elenco completo dei formati è riportato qui sotto:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Cos’è un compressore di immagini?',
          paragraphs: [
            'Un compressore di immagini è un software o servizio online che riduce la dimensione del file mantenendo la qualità visiva. Tuttavia, una compressione eccessiva può ridurre sensibilmente la qualità.',
          ],
          listTitle: 'TIPI:',
          bullets: [
            'Compressione con perdita: riduce la dimensione eliminando parte dei dati dell’immagine. La qualità può diminuire, ma spesso il calo non è evidente a occhio nudo.',
            'Compressione senza perdita: riduce la dimensione del file senza compromettere la qualità visiva.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Perché scegliere il nostro strumento?',
          bullets: [
            'Il nostro compressore immagini con AI funziona in modo fluido su tutti i dispositivi e offre i migliori risultati possibili.',
            'Puoi comprimere più immagini (anche oltre 100) in un solo clic.',
            'Non serve caricare le immagini sui nostri server: tutto avviene localmente nel tuo browser.',
            'Il nostro strumento è completamente gratuito per sempre. Puoi anche condividerlo con i tuoi amici.',
            'Puoi impostare la percentuale di compressione in base alle tue preferenze.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Guida passo dopo passo',
          steps: [
            {
              heading: '1. Seleziona le immagini che vuoi comprimere.',
              bullets: [
                'Trascina le immagini nell’area di caricamento.',
                'Puoi anche copiare le immagini e incollarle nell’area con (Ctrl + V).',
                'Puoi usare anche l’esplora file cliccando sul pulsante di selezione.',
              ],
            },
            {
              heading: '2. Seleziona la percentuale di compressione.',
              bullets: [
                'Uno slider orizzontale ti permette di scegliere comodamente il livello di compressione. Segui questi intervalli per risultati più accurati.',
              ],
              table: {
                headers: ['Percentuale di compressione', 'Risultato'],
                rows: [
                  ['1%  a  40%', 'Qualità migliore'],
                  ['41%  a  60%', 'Qualità normale (Consigliata)'],
                  ['61%  a  100%', 'Qualità bassa'],
                ],
              },
            },
            {
              heading: '3. Controlla quanto spazio hai risparmiato.',
              paragraphs: [
                'Tutte le metriche di dimensione sono mostrate in tempo reale. Puoi vedere chiaramente quanto spazio hai risparmiato sul totale e regolare la compressione in base alle tue esigenze.',
              ],
            },
            {
              heading: '4. Seleziona l’opzione di download dal pulsante di scelta.',
              bullets: [
                'ZIP: se comprimi più immagini, vedrai questa opzione. Selezionandola, tutte le immagini compresse verranno archiviate in un unico file ZIP (consigliato per molte immagini).',
                'Separate: selezionando questa opzione, le immagini verranno scaricate singolarmente e non in un unico ZIP (consigliato per piccoli numeri, meno di 10).',
              ],
            },
            {
              heading: '5. Comprimi e scarica le immagini.',
              paragraphs: [
                'Questo pulsante scaricherà automaticamente tutte le immagini compresse secondo l’opzione di download selezionata.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Vantaggi del compressore immagini.',
          bullets: [
            'Riduce i costi di archiviazione: comprimere le immagini riduce in modo significativo lo spazio necessario.',
            'Caricamento più veloce: le immagini compresse si caricano più rapidamente, migliorando l’esperienza utente su sito o app.',
            'Soluzione al limite di Gmail: Gmail consente allegati fino a 25MB, quindi la compressione ti permette di inviare più file.',
            'Condivisione e trasferimento più rapidi: i file grandi richiedono più tempo per essere trasferiti; la compressione fa risparmiare tempo e dati.',
            'Ottimizzazione delle presentazioni: immagini non compresse rendono i file molto pesanti, mentre quelle compresse riducono notevolmente la dimensione finale.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Formati supportati.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Convertitore Immagini — Converti PNG, JPG, WEBP, GIF, SVG Online Gratis | photremium.com',
      uploadDesc: 'Converti immagini tra JPG, PNG, WEBP, GIF, SVG, TIFF, BMP e altri. Convertitore online gratuito.',
      uploadKeywords: 'convertitore immagini, converti png in jpg, jpg in png, convertitore webp',
      workspaceKeywords: 'converti immagini, convertitore formato immagine',

      routeKeywords: {

        'png-to-jpg': 'png per convertire jpg, png to jpg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'jpg-to-png': 'jpg per convertire png, jpg to png, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'png-to-webp': 'png per convertire webp, png to webp, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'jpg-to-webp': 'jpg per convertire webp, jpg to webp, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'webp-to-jpg': 'webp per convertire jpg, webp to jpg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'webp-to-png': 'webp per convertire png, webp to png, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'gif-to-jpg': 'gif per convertire jpg, gif to jpg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'gif-to-png': 'gif per convertire png, gif to png, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'bmp-to-jpg': 'bmp per convertire jpg, bmp to jpg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'bmp-to-png': 'bmp per convertire png, bmp to png, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'svg-to-png': 'svg per convertire png, svg to png, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'svg-to-jpg': 'svg per convertire jpg, svg to jpg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'tiff-to-jpg': 'tiff per convertire jpg, tiff to jpg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'tiff-to-png': 'tiff per convertire png, tiff to png, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'jpg-to-gif': 'jpg per convertire gif, jpg to gif, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'png-to-gif': 'png per convertire gif, png to gif, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'jpg-to-bmp': 'jpg per convertire bmp, jpg to bmp, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'png-to-bmp': 'png per convertire bmp, png to bmp, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'webp-to-gif': 'webp per convertire gif, webp to gif, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'jpg-to-ico': 'jpg per convertire ico, jpg to ico, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'png-to-ico': 'png per convertire ico, png to ico, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'jpg-to-svg': 'jpg per convertire svg, jpg to svg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'png-to-svg': 'png per convertire svg, png to svg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'webp-to-svg': 'webp per convertire svg, webp to svg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'gif-to-svg': 'gif per convertire svg, gif to svg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'bmp-to-svg': 'bmp per convertire svg, bmp to svg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

        'tiff-to-svg': 'tiff per convertire svg, tiff to svg, convertitore immagini, converti png in jpg, jpg in png, convertitore webp',

      },
    },
    title: 'Convertitore Immagini',
    desc: 'Converti immagini tra JPG, PNG, WEBP, GIF, SVG, TIFF, BMP e altri. Converti più file in blocco.',
    toConvert: 'per convertire',
    convertSettings: 'Impostazioni Conversione',
    detected: 'Rilevato',
    convertTo: 'Converti in',
    converting: 'Conversione in corso…',
    convertToFormat: 'Converti in {format}',
    popularConversions: 'Conversioni Popolari',
    convertingTo: 'Conversione in',
    all: 'Tutti',
  },

  resizer: {
    seo: {
      uploadTitle: 'Ridimensiona Immagine Online — Ridimensiona JPG, PNG Gratis | photremium.com',
      uploadDesc: 'Ridimensiona immagini online gratuitamente in pixel o percentuale. JPG, PNG, SVG e GIF.',
      uploadKeywords: 'ridimensiona immagine, ridimensionatore immagini, ridimensiona jpg, ridimensiona png',
      workspaceTitle: 'Ridimensionamento in Corso — photremium.com Ridimensionatore',
      workspaceDesc: 'Ridimensiona immagini online gratuitamente. Nessuna registrazione richiesta.',
      workspaceKeywords: 'ridimensiona immagine, ridimensionatore immagini',
    },
    title: 'Ridimensiona Immagine',
    desc: 'Definisci le dimensioni in pixel, percentuale, centimetri o pollici e ridimensiona istantaneamente.',
    toResize: 'per ridimensionare',
    resizeSettings: 'Impostazioni Ridimensionamento',
    resizeBy: 'Ridimensiona per:',
    byPixels: 'In Pixel',
    byPercentage: 'In Percentuale',
    byCentimeters: 'In Centimetri',
    byInches: 'In Pollici',
    advanced: 'Avanzato',
    lockAspect: 'Blocca proporzioni',
    unlockAspect: 'Sblocca proporzioni',
    dontEnlarge: 'Non ingrandire se l\'originale è più piccolo',
    resizing: 'Ridimensionamento in corso…',
    resizeDownload: 'Ridimensiona e Scarica',
    blog: {
      tocTitle: 'Indice',
      title: 'Blog del Ridimensionatore Immagini',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Perché usare un ridimensionatore di immagini?',
          paragraphs: [
            'Un ridimensionatore di immagini è uno strumento o software usato per cambiare le dimensioni dell’immagine. Ti permette di regolare la dimensione dell’immagine desiderata modificando altezza, larghezza o entrambe. Questo strumento è particolarmente utile per le piattaforme social che hanno limiti di dimensione per caricare o pubblicare immagini.',
          ],
          listTitle: 'Per esempio:',
          bullets: [
            'Post Instagram: 1080 x 1080px (Quadrato)',
            'Post Facebook: 1200 x 630px',
            'Post X (ex Twitter): 1200 x 675px',
            'Storia Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Perché scegliere il nostro strumento di ridimensionamento immagini?',
          paragraphs: [
            'Il nostro ridimensionatore immagini basato su IA rende il processo di ridimensionamento preciso ed estremamente veloce. Puoi usare questo strumento su ogni dispositivo senza problemi. Non è necessario installare o scaricare alcuna app. Tutti i servizi sono disponibili online nel browser che preferisci.',
          ],
          bullets: [
            'Puoi ridimensionare più immagini (anche 100+) contemporaneamente con il nostro strumento. Se hai un dispositivo ad alte prestazioni, puoi ridimensionare comodamente da 400 a 500 immagini in pochi secondi.',
            'Tutta l’elaborazione avviene nel browser locale. Non devi caricare immagini sui nostri server. Le tue immagini non lasciano mai il dispositivo. Quindi puoi ridimensionare immagini personali senza rischi per la privacy.',
            'Sono supportate più unità per il ridimensionamento.',
            'Puoi anche mantenere il rapporto d’aspetto originale anche dopo il ridimensionamento, semplicemente selezionando la casella.',
            'Se stai ridimensionando più immagini, puoi scaricarle separatamente oppure come file ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Guida passo passo',
          steps: [
            {
              heading: 'Prima di tutto, seleziona l’immagine o le immagini che vuoi ridimensionare. Hai più modi per selezionarle.',
              bullets: [
                'Puoi semplicemente trascinare e rilasciare le immagini per ridimensionarle.',
                'È supportata anche la scorciatoia “Ctrl + V” per incollare l’immagine nel riquadro di caricamento.',
                'Cliccando su “Choose Files” si apre l’esplora file. Da lì puoi scegliere le immagini desiderate.',
              ],
            },
            {
              heading: 'Poi puoi selezionare una delle unità per ridimensionare l’immagine. Attualmente offriamo queste unità:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Dopo la scelta dell’unità, regola altezza e larghezza per ridimensionare l’immagine. Puoi anche bloccare il rapporto d’aspetto selezionando la casella.',
            },
            {
              heading: 'Poi seleziona “Don’t enlarge if original is smaller” se non vuoi che l’immagine venga ingrandita oltre la dimensione originale.',
            },
            {
              heading: 'Dopo, seleziona l’opzione di download.',
              bullets: [
                'Seleziona ZIP se vuoi ridimensionare più immagini e scaricarle tutte come un unico file zip.',
                'Oppure seleziona “separate” per scaricare ogni immagine ridimensionata separatamente.',
              ],
            },
            {
              heading: 'Infine clicca su “Resize & Download” per scaricare le immagini ridimensionate secondo l’opzione scelta.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Benefici dello strumento di ridimensionamento immagini: Il beneficio più evidente è il corretto posizionamento delle immagini nelle pagine web e nei post social.',
          tocLabel: '4. Benefici dello strumento di ridimensionamento',
          bullets: [
            'Miglioramento UX: La giusta dimensione e il corretto posizionamento delle immagini migliorano molto l’esperienza utente. Inserire immagini troppo grandi o troppo piccole senza regolazione porta a una cattiva UX.',
            'Supporto Social Media: Diverse app social hanno limiti dimensionali per la pubblicazione delle immagini. Il nostro strumento ti aiuta ad adattarle a quelle dimensioni richieste.',
            'Design Responsive: Se sei uno sviluppatore e stai creando un design responsive, devi ridimensionare le immagini in più dimensioni per supportare più dispositivi.',
            'Scelta migliore: Invece di allungare o ritagliare le immagini, che può alterarne le dimensioni, il ridimensionatore è la scelta migliore.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Formati supportati: Il nostro ridimensionatore consente di selezionare immagini in qualsiasi formato. Ecco i formati:',
          tocLabel: '5. Formati supportati',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Ritaglia Immagine Online — Ritaglia JPG, PNG, GIF Gratis | photremium.com',
      uploadDesc: 'Ritaglia JPG, PNG e GIF online facilmente. Scegli i pixel o usa l\'editor visuale.',
      uploadKeywords: 'ritaglia immagine, ritagliatore immagini, ritaglia jpg, ritaglia png',
      workspaceTitle: 'Ritaglio in Corso — photremium.com Ritagliatore',
      workspaceDesc: 'Ritaglia immagini online gratuitamente con editor visuale.',
      workspaceKeywords: 'ritaglia immagine, ritagliatore immagini',
    },
    title: 'Ritaglia Immagine',
    desc: 'Ritaglia JPG, PNG, GIF e altri con il nostro editor visuale. Proporzioni preimpostate o ritaglio libero.',
    toCrop: 'per ritagliare',
    cropSettings: 'Impostazioni Ritaglio',
    widthPx: 'Larghezza (px)',
    heightPx: 'Altezza (px)',
    positionX: 'Posizione X (px)',
    positionY: 'Posizione Y (px)',
    cropTemplate: 'Modello di Ritaglio',
    landscape: 'Orizzontale',
    portrait: 'Verticale',
    square: 'Quadrato',
    freeform: 'Libero',
    cropping: 'Ritaglio in corso…',
    cropDownload: 'Ritaglia e Scarica',
    cropDownloadAll: 'Ritaglia e Scarica Tutti',
    saveNext: 'Salva e Avanti',
    croppedNofTotal: 'Hai ritagliato {n} su {total} immagini.',
    downloadN: 'Scarica {n}',
    blog: {
      tocTitle: 'Indice',
      title: 'Blog sul Ritaglio Immagini',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Perché usare un ritagliatore di immagini?',
          paragraphs: [
            'Un ritagliatore di immagini è uno strumento software usato per ritagliare un’immagine nella forma desiderata. È molto usato per mantenere la parte utile dell’immagine ed eliminare le aree esterne indesiderate per qualsiasi scopo. Lo strumento fornisce un riquadro di ritaglio che puoi regolare nella posizione in cui vuoi ritagliare.',
          ],
          listTitle: 'Per esempio:',
          bullets: [
            'Ritagliare te stesso da una foto di gruppo.',
            'Ritagliare il tuo nome da un elenco.',
            'Ritagliare la barra di avanzamento da uno screenshot a schermo intero.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Perché scegliere il nostro ritagliatore di immagini?',
          paragraphs: [
            'Il nostro ritagliatore di immagini ti permette di ritagliare in modo preciso e molto rapido. Ti basta regolare la dimensione del riquadro di ritaglio nella posizione che vuoi ritagliare da qualsiasi immagine. Per la selezione sono supportati quasi tutti i formati immagine.',
          ],
          bullets: [
            'Puoi ritagliare tutte le immagini supportate dal tuo dispositivo. Se hai un dispositivo ad alte prestazioni, puoi persino ritagliare 100+ immagini in una volta senza lag o altri problemi.',
            'Le immagini vengono elaborate nel tuo browser locale. Non è necessario caricare alcuna immagine sui nostri server, quindi nessuna immagine lascia il tuo dispositivo. Puoi ritagliare immagini personali senza rischi di sicurezza.',
            'Molti strumenti mostrano errore di formato immagine non valido. Il nostro ritagliatore risolve questo problema supportando quasi tutti i formati immagine.',
            'Se ritagli molte immagini insieme, il nostro strumento ti consente di scaricare le immagini ritagliate in ZIP o come file separati in base alla tua preferenza.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Guida passo passo',
          steps: [
            {
              heading: '1. Per prima cosa, seleziona l’immagine che vuoi ritagliare. Il nostro ritagliatore supporta anche la selezione multipla in una sola volta.',
              bullets: [
                'Trascina e rilascia le immagini nel riquadro di upload per ritagliarle.',
                'Puoi anche selezionare le immagini dall’esplora file cliccando il pulsante choose files nel riquadro di ritaglio.',
                'È supportata anche la scorciatoia Ctrl + V per incollare immagini nel riquadro di upload.',
              ],
            },
            {
              heading: '2. Poi regola dimensione e posizione del riquadro di ritaglio sull’immagine.',
            },
            {
              heading: '3. Puoi anche regolare il riquadro inserendo manualmente altezza, larghezza, posizione orizzontale e posizione verticale.',
            },
            {
              heading: '4. Puoi anche usare alcuni template pronti:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Poi devi scegliere una delle opzioni di download.',
              bullets: [
                'ZIP: scegli questa opzione se ritagli molte immagini e vuoi scaricarle tutte come un unico file.',
                'Separate: se vuoi scaricare tutte le immagini ritagliate separatamente, scegli questa opzione dal pulsante toggle.',
              ],
            },
            {
              heading: '6. Poi clicca il pulsante Crop & Download per scaricare tutte le immagini ritagliate secondo le dimensioni preimpostate.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Vantaggi del ritaglio immagini: il ritagliatore di immagini offre diversi vantaggi nel mondo digitale. Alcuni sono descritti qui sotto:',
          tocLabel: '4. Vantaggi del ritaglio immagini',
          bullets: [
            'Adattare le immagini nei frame: il ritagliatore aiuta a inserire correttamente le immagini in un frame, che può trovarsi su una pagina web o su una piattaforma social.',
            'Migliorare la UX: il corretto posizionamento delle immagini migliora l’esperienza utente, quindi il ritaglio aiuta molto la UX.',
            'Rimuovere bordi indesiderati: puoi eliminare i bordi non necessari dall’immagine per renderla più pulita.',
            'Isolare l’oggetto desiderato: puoi anche separarti da una foto di gruppo.',
            'Risparmiare spazio: il ritaglio riduce lo spazio occupato perché elimina l’area superflua e mantiene solo la parte utile.',
            'Ottimizzare le presentazioni: se una presentazione normale con 10 immagini non ritagliate occupa circa 30MB, la stessa con immagini ritagliate può occupare circa 10MB.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Formati supportati:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Editor Foto Online — Modifica Immagini Gratis con Testo, Effetti e Cornici | photremium.com',
      desc: 'Modifica foto online gratuitamente — aggiungi testo, effetti, cornici e adesivi. Tutto nel tuo browser.',
      keywords: 'editor foto, editor foto online, modifica foto online gratis, aggiungi testo all\'immagine',
    },
    title: 'Editor Foto',
    desc: 'Arricchisci le tue foto con testo, effetti, cornici e adesivi. Strumenti di editing semplici.',
    toEdit: 'per modificare',
    textTypography: 'Testo e Tipografia',
    textTypographyDesc: 'Aggiungi testo personalizzato con vari font, colori, ombre e opzioni di posizionamento.',
    filtersEffects: 'Filtri ed Effetti',
    filtersEffectsDesc: 'Applica filtri professionali, regola luminosità, contrasto, saturazione e altro.',
    framesStickers: 'Cornici e Adesivi',
    framesStickersDesc: 'Scegli tra belle cornici e divertenti adesivi per migliorare le tue immagini.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Rimuovi Sfondo da Immagine Online Gratis | photremium.com',
      uploadDesc: 'Rimuovi rapidamente gli sfondi con alta precisione. Rimozione sfondo online gratuita — nel tuo browser.',
      uploadKeywords: 'rimuovi sfondo, rimozione sfondo, rimuovi sfondo immagine, sfondo trasparente',
      workspaceTitle: 'Rimozione Sfondo — photremium.com Rimozione Sfondo',
      workspaceDesc: 'Rimuovi sfondi dalle immagini online gratuitamente.',
      workspaceKeywords: 'rimuovi sfondo, sfondo trasparente',
    },
    title: 'Rimuovi Sfondo',
    desc: 'Rimuovi istantaneamente gli sfondi con rilevamento avanzato dei bordi. 100% gratuito, tutto nel browser.',
    toRemoveBg: 'per rimuovere lo sfondo',
    backgroundRemover: 'Rimozione Sfondo',
    processingProgress: 'Avanzamento Elaborazione',
    processingNImages: 'Elaborazione di {n} immagine/i…',
    allNProcessed: 'Tutte le {n} immagini elaborate!',
    nOfTotalDone: '{n} / {total} completate',
    fileName: 'Nome File',
    dimensions: 'Dimensioni',
    status: 'Stato',
    statusDone: '✓ Completato',
    statusProcessing: '⏳ Elaborazione',
    statusError: '✗ Errore',
    statusPending: '⏸ In attesa',
    badgeDone: 'Completato',
    badgeProcessing: 'Elaborazione…',
    badgeError: 'Errore',
    removingBg: 'Rimozione sfondo…',
    retry: 'Riprova',
    downloading: 'Download in corso…',
    nextImage: 'Immagine Successiva',
  },

  watermark: {
    seo: {
      uploadTitle: 'Filigrana Immagine Online — Aggiungi Testo e Logo Gratis | photremium.com',
      uploadDesc: 'Aggiungi filigrane di testo o immagine alle tue foto in secondi. Gratuito, veloce e privato.',
      uploadKeywords: 'filigrana immagine, aggiungi filigrana, filigrana testo, filigrana logo',
      workspaceTitle: 'Filigranatura Immagini — photremium.com Strumento Filigrana',
      workspaceDesc: 'Aggiungi filigrane alle immagini online gratuitamente.',
      workspaceKeywords: 'filigrana immagine, aggiungi filigrana',
    },
    title: 'Filigrana Immagine',
    desc: 'Aggiungi filigrane di testo o logo alle immagini. Personalizza font, opacità, dimensione e posizione.',
    toWatermark: 'per aggiungere filigrana',
    watermarkTools: 'Strumenti Filigrana',
    addText: 'Aggiungi Testo',
    addImage: 'Aggiungi Immagine',
    layersN: 'Livelli ({n})',
    noLayers: 'Nessun livello aggiunto',
    textLayer: 'Livello Testo',
    imageLayer: 'Livello Immagine',
    watermarkDownloadAll: 'Filigrana e Scarica Tutti',
    watermarkDownload: 'Filigrana e Scarica',
    nextImage: 'Immagine Successiva',
    selectToEdit: 'Seleziona un\'immagine o un testo per iniziare a modificare',
    bold: 'Grassetto',
    italic: 'Corsivo',
    underline: 'Sottolineato',
    bgColor: 'Colore Sfondo',
    textColor: 'Colore Testo',
    alignLeft: 'Allinea a Sinistra',
    alignCenter: 'Centra',
    alignRight: 'Allinea a Destra',
    opacity: 'Opacità',
    stroke: 'Contorno',
    strokeWidth: 'Spessore Contorno',
    strokeColor: 'Colore Contorno',
    tileRepeat: 'Ripeti',
    tilePattern: 'Pattern',
    spacing: 'Spaziatura',
    snapToCenter: 'Aggancia al Centro',
    duplicate: 'Duplica',
    delete: 'Elimina',
    flipHorizontal: 'Capovolgi Orizzontalmente',
    flipVertical: 'Capovolgi Verticalmente',
    rotateLeft: 'Ruota a Sinistra',
    rotateRight: 'Ruota a Destra',
    cornerRadius: 'Raggio Angolo',
    borderStroke: 'Bordo / Contorno',
    borderWidth: 'Spessore Bordo',
    color: 'Colore',
    style: 'Stile',
    hide: 'Nascondi',
    show: 'Mostra',
    lock: 'Blocca',
    unlock: 'Sblocca',
    solid: 'Continuo',
    dashed: 'Tratteggiato',
    dotted: 'Punteggiato',
    double: 'Doppio',
    tileSingle: 'Singolo',
    tile2x2: 'Griglia 2×2',
    tile3x3: 'Griglia 3×3',
    removeAllConfirm: 'Rimuovere tutte le immagini e le filigrane?',
    dimMismatch: 'Le immagini caricate hanno dimensioni diverse. Per risultati migliori, usa immagini della stessa risoluzione.',
    clearBackground: 'Rimuovi Sfondo',
    typeHere: 'Scrivi qui...',
    linkCorners: 'Collega angoli',
    separateCorners: 'Separa angoli',
    blog: {
      tocTitle: 'Indice',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Panoramica Strumento Filigrana',
          title: 'Come aggiungere una filigrana alle immagini online — La guida completa allo strumento Filigrana di Photremium',
          paragraphs: [
            'Hai appena finito di modificare una bella fotografia. Forse è uno scatto prodotto per il tuo negozio, un ritratto da una sessione cliente, o un’opera digitale su cui hai lavorato per ore. E ora arriva la domanda che prima o poi ogni creatore si pone: come la proteggi prima di condividerla?',
            'La risposta su cui la maggior parte dei professionisti converge è: una filigrana — e a ragione. Una filigrana posizionata correttamente agisce come una firma permanente sul tuo lavoro, lo rende tracciabile, riconoscibile e molto più difficile da rubare.',
            'Il problema che molti incontrano è questo: gli strumenti online disponibili sono troppo macchinosi, bloccati dietro abbonamenti, o producono una filigrana così pesante da rovinare completamente l’immagine.',
            'Lo strumento Filigrana di Photremium è stato creato proprio per risolvere tutto questo. È un workspace di filigranatura completamente basato su browser, gratuito, senza account, che funziona direttamente nel tuo browser senza caricare mai i file su un server. Tutto resta locale, tutto resta veloce, e il livello di controllo creativo è paragonabile a quello di un software desktop. In questa guida ti spieghiamo esattamente come funziona, per chi è pensato e come ottenere i migliori risultati — ogni volta.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Cos’è una filigrana',
          title: 'Che cos’è una filigrana e perché è importante?',
          paragraphs: [
            'Prima di entrare nello strumento, vale la pena capire cosa fa una filigrana e perché tanti fotografi, designer e creatori di contenuti la considerano imprescindibile.',
            'Una filigrana è un overlay visibile aggiunto a un’immagine — tipicamente testo, un logo o un simbolo di copyright — che identifica il creatore o il proprietario del contenuto. A differenza dei metadati (che sono nascosti nel file e possono essere rimossi in pochi secondi), una filigrana è incorporata visivamente nell’immagine. Non puoi semplicemente fare clic destro e rimuoverla senza degradare in modo evidente la qualità dell’immagine.',
          ],
          subSections: [
            {
              title: 'Perché i creatori usano le filigrane',
              paragraphs: [
                'Le ragioni pratiche per applicare una filigrana alle immagini si riducono a tre punti chiave.',
              ],
              bullets: [
                'Identificazione della proprietà. Quando il tuo lavoro viene condiviso sui social, su Pinterest o incorporato in post di blog, l’attribuzione originale spesso va persa. Una filigrana garantisce che il tuo nome o il tuo brand accompagni l’immagine ovunque finisca.',
                'Deterrenza dal furto. Molti ladri occasionali cercano la strada più semplice. Una filigrana dall’aspetto professionale, ben posizionata e leggermente trasparente invia un segnale chiaro: questa immagine appartiene a qualcuno che tiene al proprio lavoro.',
                'Protezione dei portfolio clienti. I fotografi che inviano anteprime ai clienti prima del pagamento finale usano spesso le filigrane per evitare che le anteprime vengano utilizzate senza saldare la fattura. Una filigrana discreta protegge senza rendere la preview troppo invasiva.',
              ],
            },
            {
              title: 'Chi dovrebbe filigranare le proprie immagini',
              paragraphs: [
                'Se rientri in una delle seguenti categorie, filigranare le immagini prima di condividerle online non è opzionale — è essenziale:',
              ],
              bullets: [
                'Fotografi freelance che condividono gallerie con i clienti',
                'Graphic designer che distribuiscono campioni di portfolio',
                'Venditori e-commerce che mostrano foto prodotto prima di accordi di licensing',
                'Artisti digitali che condividono lavori su piattaforme social',
                'Blogger e content creator le cui immagini vengono riutilizzate regolarmente',
                'Contributor di stock photo che costruiscono un brand riconoscibile',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Pannelli del workspace',
          title: 'Dentro lo strumento Filigrana di Photremium: un workspace a tre pannelli per flussi reali',
          paragraphs: [
            'Ciò che distingue lo strumento filigrana di Photremium dai watermarker online di base è il design del workspace. Invece di un semplice “digita testo, scegli posizione, fatto”, lo strumento offre un layout a tre pannelli che richiama i software di design professionali — ma gira interamente nel browser, senza alcuna installazione.',
          ],
          subSections: [
            {
              title: 'Il pannello canvas di sinistra',
              paragraphs: [
                'Il pannello canvas occupa la porzione più ampia dello schermo e mostra esattamente come appare l’immagine con la filigrana in tempo reale. Ogni modifica — regolazione dell’opacità, spostamento di un livello di testo, ridimensionamento di un logo — si riflette istantaneamente sul canvas. Non esiste un pulsante “anteprima”. Quello che vedi è quello che ottieni.',
                'Il canvas include anche una toolbar di zoom integrata, che ti permette di ingrandire per un allineamento preciso o di ridurre per vedere l’insieme. La funzione zoom-to-fit calcola automaticamente la scala iniziale migliore in base alla dimensione dello schermo, così anche le immagini ad alta risoluzione risultano comode da lavorare. Le guide di allineamento appaiono dinamicamente quando trascini un livello vicino al centro orizzontale o verticale dell’immagine, agganciando la filigrana al centro con una precisione soddisfacente che di solito si ottiene solo in Photoshop.',
              ],
            },
            {
              title: 'Il pannello impostazioni di destra',
              paragraphs: [
                'Il pannello di destra è il centro di controllo. Qui gestisci i livelli della filigrana, ne personalizzi l’aspetto e avvii l’esportazione finale. Su desktop è fisso sul lato destro dello schermo. Su mobile si apre come una bottom sheet attivata da un pulsante a ingranaggio flottante, così non copre il canvas mentre lavori.',
                'All’interno del pannello destro trovi il gestore dei livelli, che elenca ogni elemento di filigrana aggiunto. Ogni voce mostra il tipo di livello (testo o immagine), il nome o contenuto e tre pulsanti rapidi: toggle di visibilità (icona occhio), toggle di blocco per fissare la posizione e pulsante di eliminazione.',
              ],
            },
            {
              title: 'La striscia di anteprime a sinistra (modalità multi-immagine)',
              paragraphs: [
                'Quando lavori con più immagini alla volta — ad esempio un batch di foto prodotto o un’intera sessione di ritratti — appare una striscia verticale di miniature sul lato sinistro dello schermo. È la coda immagini, che mostra le anteprime di ogni file caricato. Cliccando una miniatura, il canvas passa immediatamente a quell’immagine, consentendoti di verificare l’aspetto della filigrana su composizioni diverse senza perdere le impostazioni dei livelli.',
                'La striscia mostra anche la dimensione del file in KB o MB e il formato (JPG, PNG, WEBP), così sai sempre con cosa stai lavorando a colpo d’occhio.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Step-by-step',
          title: 'Step-by-step: come aggiungere una filigrana su Photremium',
          paragraphs: [
            'Questa guida si basa direttamente sul funzionamento interno dello strumento — dal sistema di upload drag-and-drop al motore di rendering su canvas che scrive la filigrana in modo permanente sull’immagine prima del download.',
          ],
          steps: [
            {
              heading: 'Passo 1 — Carica le tue immagini',
              paragraphsBefore: [
                'Vai su photremium.com/watermark-image. Atterrerai nella schermata di upload con una dropzone pulita al centro della pagina.',
                'Hai tre modi per inserire le immagini nello strumento:',
              ],
              bullets: [
                'Drag and drop. Trascina uno o più file immagine dal desktop direttamente nella dropzone. Lo strumento accetta i formati standard — JPEG, PNG, WEBP e altri. Quando trascini i file sull’area di lavoro, appare un bordo viola con il messaggio “Drop images to add for watermarking”, così capisci che il drop è stato registrato.',
                'Click to browse. Clicca il pulsante “Choose Files” dentro la dropzone per aprire il selettore file. Puoi selezionare più file insieme usando Ctrl+Click (Windows) o Cmd+Click (Mac).',
                'Paste from clipboard. Se hai copiato un’immagine negli appunti — da uno screenshot, un’altra app o il browser — premi semplicemente Ctrl+V (o Cmd+V su Mac) nella pagina watermark e l’immagine verrà caricata direttamente nel workspace. Funziona anche se sono già presenti più immagini.',
              ],
              paragraphsAfter: [
                'Quando la prima immagine viene caricata, il workspace passa dalla schermata di upload all’editor completo a tre pannelli e il canvas mostra l’immagine con uno zoom fit-to-screen calcolato automaticamente.',
              ],
            },
            {
              heading: 'Passo 2 — Aggiungi un livello di filigrana testo',
              paragraphsBefore: [
                'Clicca il pulsante viola “Add Text” nel pannello destro. Sul canvas appare un nuovo livello di testo con il placeholder “Type here...” già selezionato.',
                'Puoi iniziare a digitare subito. Il testo viene renderizzato live sul canvas in Arial bianco a una dimensione predefinita adeguata all’immagine. Dalla toolbar in alto che appare quando il livello testo è selezionato, puoi personalizzare ogni aspetto del testo:',
              ],
              bullets: [
                'Font family — scegli tra 12 font integrati tra cui Arial, Georgia, Impact, Brush Script MT, Comic Sans MS e altri',
                'Font size — inserisci un valore in pixel o usa i controlli incrementali',
                'Bold, italic, underline — attiva qualsiasi combinazione di stili',
                'Text color — clicca il campione colore per aprire il color picker e scegliere qualsiasi colore esadecimale',
                'Background color — aggiungi un riquadro colorato dietro il testo per un look da etichetta o badge',
                'Stroke (outline) — imposta spessore e colore del contorno per massima leggibilità su immagini chiare o scure',
                'Opacity — regola da 0% (invisibile) a 100% (opaco); la maggior parte delle filigrane è tra 30% e 60%',
                'Alignment — allinea a sinistra, centro o destra all’interno del bounding box',
                'Rotation — ruota il livello testo a qualsiasi angolo con punti di snap magnetici a 0°, 90°, 180° e 270° per posizionamenti rapidi',
              ],
              paragraphsAfter: [
                'Per spostare il testo, clicca e trascina dove vuoi sul canvas. Per una posizione precisa al pixel, usa i tasti freccia della tastiera (tieni premuto Shift per spostarti di 10 pixel). Per ridimensionare la casella di testo, trascina uno degli otto handle (angoli e lati) che compaiono attorno al livello selezionato.',
              ],
            },
            {
              heading: 'Passo 3 — Aggiungi un livello di filigrana immagine (logo)',
              paragraphsBefore: [
                'Se vuoi usare un logo, una firma o un’immagine come filigrana invece del testo — o in aggiunta — clicca il pulsante blu “Add Image” nel pannello destro. Si aprirà il selettore file per scegliere l’immagine filigrana dal tuo dispositivo.',
                'Lo strumento ridimensiona automaticamente l’immagine filigrana a circa il 30% della larghezza del canvas mantenendo il rapporto d’aspetto originale e la centra sul canvas. Da lì puoi trascinarla dove vuoi, ridimensionarla usando gli handle agli angoli (con proporzioni bloccate) o ruotarla con l’apposita maniglia di rotazione sopra il livello selezionato.',
                'Per i livelli filigrana di tipo immagine, il pannello destro mostra controlli aggiuntivi:',
              ],
              bullets: [
                'Opacity — come per i livelli testo, ideale per loghi PNG trasparenti',
                'Flip horizontal / Flip vertical — specchia la filigrana se necessario',
                'Border width, border color, and border style — aggiungi un bordo visibile intorno al logo',
                'Border radius — arrotonda gli angoli del logo, in modo uniforme o con controllo per singolo angolo',
                'Rotation — stesso comportamento di rotazione fluida dei livelli testo',
              ],
            },
            {
              heading: 'Passo 4 — Configura il tiling (opzionale)',
              paragraphsBefore: [
                'Una delle funzioni più potenti è il tiling — la possibilità di ripetere la filigrana su tutta l’immagine in uno schema a griglia. È particolarmente utile quando vuoi rendere un’immagine inutilizzabile per la ripubblicazione, non solo brandizzarla.',
                'Con un livello selezionato, cerca l’opzione tile nella toolbar. Puoi impostarla su:',
              ],
              bullets: [
                'None — posizionamento singolo (predefinito)',
                'Grid 2×2 — ripete la filigrana in uno schema 2 colonne, 2 righe',
                'Grid 3×3 — ripete in una griglia 3×3 per una copertura più densa',
              ],
              paragraphsAfter: [
                'Puoi anche regolare la spaziatura del tile, che controlla la distanza tra ogni ripetizione. Il canvas mostra anteprime fantasma di tutte le copie in modo da visualizzare il pattern completo prima del download.',
              ],
            },
            {
              heading: 'Passo 5 — Usa il gestore livelli per più filigrane',
              paragraphsBefore: [
                'Puoi aggiungere quanti livelli vuoi — mescolando liberamente filigrane testo e immagine. Il gestore livelli nel pannello destro li elenca tutti. Puoi:',
              ],
              bullets: [
                'Mostrare/nascondere i livelli con l’icona occhio — utile per passare tra diverse versioni senza eliminare nulla',
                'Bloccare un livello per evitare spostamenti accidentali mentre lavori su altri livelli',
                'Eliminare un livello definitivamente',
              ],
              paragraphsAfter: [
                'Cliccando una voce nella lista dei livelli, il livello corrispondente viene selezionato sul canvas, facilitando il passaggio tra livelli senza doverli cercare sull’immagine.',
              ],
            },
            {
              heading: 'Passo 6 — Passa tra più immagini',
              paragraphsBefore: [
                'Se hai caricato più di un’immagine, usa la striscia di miniature a sinistra per cambiare l’immagine attiva sul canvas. I livelli di filigrana che hai configurato si applicano in modo universale — verranno renderizzati su ogni immagine del batch in fase di export.',
                'Lo strumento esegue anche un controllo di coerenza della risoluzione nel batch. Se le immagini hanno dimensioni molto diverse (più del 5% di differenza in larghezza o altezza), appare un avviso che segnala possibili differenze nella posizione della filigrana. Il motore gestisce questo scenario con un algoritmo di riposizionamento proporzionale: calcola la posizione della filigrana come percentuale delle dimensioni dell’immagine di riferimento e applica la stessa proporzione a tutte le altre immagini, preservando l’intento visivo anche con risoluzioni diverse.',
              ],
            },
            {
              heading: 'Passo 7 — Imposta le preferenze di download',
              paragraphsBefore: [
                'Per lavori con una sola immagine, clicca il pulsante “Download” sotto il canvas per salvare direttamente l’immagine filigranata. Il nome file viene impostato automaticamente con “-watermarked” aggiunto al nome originale prima dell’estensione. Le immagini JPEG vengono esportate a qualità 0.95 — abbastanza alta da essere indistinguibili dall’originale a dimensioni di visualizzazione normali. Le PNG vengono esportate come PNG lossless.',
                'Per i lavori batch (più immagini), hai due modalità di download selezionabili nel pannello destro:',
              ],
              bullets: [
                'ZIP file — tutte le immagini filigranate vengono inserite in un unico archivio ZIP scaricabile con un clic. Lo strumento carica JSZip in modo dinamico per gestire la compressione.',
                'Separate files — ogni immagine viene scaricata come file separato con un breve intervallo tra un download e l’altro per evitare il throttling del browser.',
              ],
            },
            {
              heading: 'Passo 8 — Scarica e verifica',
              paragraphsBefore: [
                'Dopo aver cliccato il pulsante di download (o il pulsante “Watermark & Download All” per i batch), lo strumento renderizza ogni immagine su un elemento canvas HTML5 nascosto a risoluzione nativa completa — non alla dimensione di anteprima che vedi a schermo. Questo significa che l’immagine esportata ha il 100% delle dimensioni originali con la filigrana disegnata in proporzione corretta. Apri il file scaricato e zooma per verificare che posizionamento e qualità della filigrana siano all’altezza delle aspettative.',
                'Se qualcosa non è perfetto, torna nel workspace — i tuoi livelli sono ancora lì — regola e scarica di nuovo.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Consigli pro',
          title: 'Consigli pro per ottenere i migliori risultati',
          bullets: [
            'Usa un logo PNG semi-trasparente per il massimo della professionalità. Una filigrana logo con sfondo trasparente al 40–50% di opacità appare molto più curata del testo pieno. Esporta il logo dal tuo strumento di design in PNG con trasparenza alpha prima di usarlo come livello immagine.',
            'Posiziona la filigrana dove il ritaglio toglierebbe valore. L’angolo in basso a destra è la posizione più comune — ed è la più facile da ritagliare. Per una protezione più forte, posiziona la filigrana su un’area visivamente importante dell’immagine, come un volto, un dettaglio prodotto o il punto focale. L’opzione tile diagonale è ancora più difficile da rimuovere senza degradare l’immagine.',
            'Usa la funzione di blocco quando lavori con più livelli. Una volta soddisfatto della posizione principale della filigrana, blocca quel livello prima di aggiungerne altri. Così eviti di spostarlo accidentalmente.',
            'Testa su aree chiare e scure. Una filigrana bianca è invisibile su un cielo chiaro ma leggibile su un’ombra scura. Aggiungi un leggero contorno o uno sfondo delicato per garantire la leggibilità indipendentemente dal contenuto sottostante.',
            'Le scorciatoie da tastiera fanno sempre risparmiare tempo. I tasti freccia spostano i livelli selezionati di un pixel alla volta. Shift+Arrow sposta di dieci pixel alla volta. Il tasto Delete elimina immediatamente il livello selezionato. Queste scorciatoie rendono le regolazioni molto più rapide rispetto al trascinamento.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Privacy e sicurezza',
          title: 'Privacy e sicurezza: perché il processing nel browser è importante',
          paragraphs: [
            'Una preoccupazione comune tra i creatori che usano strumenti online è: dove vanno davvero le immagini? Con strumenti di filigranatura basati su server, l’immagine viene caricata sul server del provider, elaborata lì e poi restituita. Questo significa che lavori inediti, foto clienti o immagini di prodotto sensibili passano attraverso l’infrastruttura di qualcun altro.',
            'Lo strumento filigrana di Photremium elabora tutto localmente nel tuo browser. Le immagini vengono caricate in memoria tramite la File API del browser e non vengono mai trasmesse su internet. Il rendering della filigrana avviene su un elemento canvas HTML5 in JavaScript, interamente nel tuo tab del browser. Quando chiudi la pagina o clicchi “Start Over”, tutti i dati immagine vengono rilasciati dalla memoria e scartati. Nulla viene archiviato al di fuori del tuo dispositivo.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Riepilogo finale',
          title: 'Perché lo strumento Filigrana di Photremium merita un posto nel tuo workflow regolare',
          paragraphs: [
            'Esistono decine di strumenti di filigranatura online. Ciò che distingue uno strumento da salvare nei preferiti da uno da dimenticare è spesso una combinazione di velocità, controllo e fiducia.',
            'La velocità conta perché filigranare non dovrebbe aggiungere tempo al tuo workflow di post-produzione. Lo strumento Photremium si carica all’istante, elabora localmente ed esporta a piena risoluzione in pochi secondi — anche con batch molto grandi. Niente attese di elaborazione server, niente code e niente tempi di rendering che aumentano con il numero di utenti online contemporanei.',
            'Il controllo conta perché una filigrana che appare sbagliata è peggio di nessuna filigrana — rende il tuo brand poco professionale. Il sistema a livelli, i controlli per proprietà nella toolbar, l’anteprima canvas in tempo reale e il supporto alle scorciatoie da tastiera offrono un livello di controllo davvero paragonabile ai software desktop dedicati.',
            'La fiducia conta perché il tuo lavoro inedito ha valore. Sapere che le tue immagini non viaggiano mai su internet verso un server di terze parti significa poter filigranare foto clienti, immagini prodotto non rilasciate e lavori creativi sensibili senza preoccupazioni legate alla gestione dei dati, a breach server o a cambi di policy del cloud provider.',
            'Che tu stia aggiungendo un rapido avviso di copyright a una sola foto o elaborando un intero shooting da 200 immagini per una galleria clienti, lo strumento Filigrana Immagine di Photremium ti dà tutto il necessario per farlo bene — completamente gratis, completamente privato e con abbastanza flessibilità creativa per far sembrare la filigrana parte dell’immagine, non un elemento appiccicato sopra.',
            'Vai su photremium.com/watermark-image e provalo. La tua prima immagine filigranata è letteralmente a trenta secondi di distanza.',
            'Photremium offre una suite di strumenti di editing e processing immagini basati su browser. Tutti gli strumenti funzionano localmente nel browser — le tue immagini restano sul tuo dispositivo.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Generatore QR Code — Crea e Personalizza Gratis | photremium.com',
      inputDesc: 'Genera QR code personalizzati per URL, testo, WiFi, contatti, email e Google Maps. Personalizza colori, forme, cornici e logo.',
      inputKeywords: 'generatore qr code, crea qr code, qr code personalizzato',
      customizeTitle: 'Personalizza QR Code — photremium.com Generatore QR Code',
      customizeDesc: 'Personalizza stile, colore, cornice e logo del QR code. Scarica in PNG, JPG, SVG, WEBP o PDF.',
      customizeKeywords: 'personalizza qr code, stile qr code, colori qr code',
    },
    title: 'Generatore QR Code',
    desc: 'Genera, personalizza e scarica QR code per URL, testo, WiFi, contatti, email e mappe.',
    generate: 'Genera',
    scanQrCode: 'Scansiona QR Code',
    tabUrl: 'Link / URL',
    tabText: 'Testo',
    tabWifi: 'WiFi',
    tabContact: 'Contatto',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Inserisci URL',
    enterText: 'Inserisci Testo',
    networkName: 'Nome Rete (SSID)',
    password: 'Password',
    encryption: 'Crittografia',
    hiddenNetwork: 'Rete Nascosta',
    contactName: 'Nome Contatto (opzionale)',
    phoneNumber: 'Numero di Telefono',
    emailAddress: 'Indirizzo Email',
    subject: 'Oggetto (opzionale)',
    body: 'Corpo (opzionale)',
    searchLocation: 'Cerca Posizione',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Scrivi il tuo testo qui…',
    wifiNamePlaceholder: 'La Mia WiFi',
    passwordPlaceholder: 'Password',
    contactPlaceholder: 'Mario Rossi',
    phonePlaceholder: '+39 012 345 6789',
    emailPlaceholder: 'esempio@gmail.com',
    subjectPlaceholder: 'Oggetto',
    bodyPlaceholder: 'Corpo dell\'email…',
    locationPlaceholder: 'Cerca città, indirizzo, luogo…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Nessuno',
    characters: 'caratteri',
    generateCustomize: 'Genera e Personalizza',
    editQrData: 'Modifica Dati QR',
    styleShape: 'Stile e Forma',
    colorTab: 'Colore',
    framesTab: 'Cornici',
    logoTab: 'Logo',
    templatesTab: 'Modelli',
    fileFormatTab: 'Formato File',
    fgColor: 'Colore Primo Piano',
    bgColor: 'Colore Sfondo',
    enableGradient: 'Abilita Gradiente',
    gradientType: 'Tipo Gradiente',
    linear: 'Lineare',
    radial: 'Radiale',
    selectFrame: 'Seleziona Cornice',
    selectLogo: 'Seleziona Logo',
    uploadCustomLogo: 'O Carica Logo Personalizzato',
    uploadImage: 'Carica Immagine',
    downloadFormat: 'Formato Download',
    preview: 'Anteprima',
    downloadFormatBtn: 'Scarica {format}',
    pngDesc: 'Senza perdita, supporta trasparenza',
    jpgDesc: 'Formato file popolare/universale',
    webpDesc: 'Formato moderno, miglior qualità/dimensioni',
    svgDesc: 'Grafica vettoriale scalabile',
    pdfDesc: 'Documento pronto per la stampa',
    lat: 'Lat:',
    lng: 'Lng:',
    qrCode: 'QR Code',
    scanMe: 'SCANSIONAMI',
    scanHere: 'SCANSIONA QUI',
    blog: {
      card1: {
        title: '1. Che cos’è un codice QR?',
        intro1: 'QR è l’abbreviazione di “Quick Response code”. Poiché le informazioni memorizzate vengono decodificate molto velocemente, si chiama codice Quick Response (QR).',
        intro2: 'Il codice QR è un codice digitale bidimensionale leggibile solo dalle macchine. I dati al suo interno non possono essere letti direttamente da una persona. Contiene moduli per memorizzare informazioni come testo, numeri di contatto, link e posizioni su Google Maps, ecc.',
        inventionTitle: 'Come è stato inventato il codice QR:',
        inventionText: 'Il codice QR è stato inventato nel 1994. Masahiro Hara e il suo team lavoravano presso un’azienda giapponese chiamata Denso Wave, che produceva componenti auto per Toyota. Volevano un codice capace di memorizzare molte più informazioni rispetto a un barcode tradizionale, e così inventarono il QR code.',
        keyFeaturesTitle: 'Caratteristiche principali di un codice QR',
        keyFeatures: [
          {
            title: 'Come funziona il QR',
            text: 'Inserisci il testo o il link per generare il relativo codice QR. Il generatore crea moduli quadrati in base alle informazioni. Ogni modulo rappresenta un bit e i bit codificano i caratteri.',
          },
          {
            title: 'Struttura del codice QR',
            text: 'Un codice QR contiene tre grandi quadrati per identificare l’orientamento del codice e piccoli moduli quadrati che memorizzano i bit (informazioni).',
          },
          {
            title: 'Capacità dati del codice QR',
            text: 'In genere un codice QR memorizza più informazioni di un codice a barre. È una versione avanzata del barcode, di fatto un barcode bidimensionale. Un codice QR può contenere circa 200 caratteri. Può arrivare anche a 400 caratteri, ma la scansione può diventare più difficile. Oltre 400 caratteri, il codice può risultare molto complesso e spesso non scansionabile.',
          },
          {
            title: 'Rilevamento errori nei codici QR',
            text: 'Un codice QR può restare scansionabile anche se una parte è graffiata o alcuni bit sono alterati. Il QR code usa la tecnica Reed-Solomon per rilevare gli errori e correggerli dopo l’identificazione.',
          },
        ],
        errorTitle: 'Livelli di correzione errori del codice QR:',
        errorIntro: 'In base al caso d’uso vengono applicate diverse tecniche di rilevamento e correzione errori, come segue:',
        errorHeaders: {
          level: 'Livello',
          recovery: 'Capacità di recupero',
          bestUse: 'Uso consigliato',
        },
        errorRows: [
          {
            level: 'Basso (L)',
            recovery: '~7%',
            useCases: [
              'Questa tecnica si usa quando il QR code è mostrato su schermi digitali, siti web o in ambienti puliti.',
              'È adatta quando il QR code contiene poche informazioni, come Gmail, numero di contatto o testo breve.',
            ],
          },
          {
            level: 'Medio (M)',
            recovery: '~15%',
            useCases: [
              'Per volantini e poster in ambienti puliti, quando il rischio di danno è trascurabile.',
            ],
          },
          {
            level: 'Quartile (Q)',
            recovery: '~25%',
            useCases: [
              'Quando il QR code deve essere installato in ambienti difficili, ad esempio fabbrica o esterno.',
              'Anche quando è necessario un piccolo logo al centro che copre alcuni bit: in questo caso serve questo livello di correzione.',
            ],
          },
          {
            level: 'Alto (H)',
            recovery: '~30%',
            useCases: [
              'Usato quando è possibile un danno rilevante al codice QR.',
              'Quando loghi grandi coprono il centro del codice QR.',
              'Anche quando è richiesta una personalizzazione grafica molto intensa.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Perché scegliere il nostro generatore di codici QR?',
        intro: 'Il nostro generatore rende la creazione di codici QR estremamente veloce, sicura e semplice. Puoi personalizzare il tuo codice per renderlo più avanzato, professionale e in linea con il tema del tuo brand. Tutte le personalizzazioni, dai colori all’inserimento del logo, sono gratuite per sempre.',
        strengths: [
          {
            title: 'Personalizzazione professionale:',
            text: 'Puoi generare e personalizzare tutti i codici QR che ti servono senza costi. Tutte le funzioni sono completamente gratuite. Puoi applicare colori a gradiente, forme diverse per i moduli quadrati, loghi personalizzati e molte altre opzioni.',
          },
          {
            title: 'Supporto a più formati:',
            text: 'Il nostro generatore offre diversi formati di download per maggiore comodità. Devi solo scegliere il formato preferito prima di scaricare. Attualmente supportiamo questi formati:',
          },
          {
            title: 'Template predefiniti:',
            text: 'Puoi usare gradienti e cornici predefiniti che rendono il tuo codice QR più professionale.',
          },
          {
            title: 'Supporto logo personalizzato:',
            text: 'Puoi caricare il logo del tuo brand che verrà adattato automaticamente al centro del codice QR. In alternativa puoi scegliere un logo dalla libreria integrata con oltre 30 loghi disponibili.',
          },
          {
            title: 'Anteprima in tempo reale:',
            text: 'Durante la personalizzazione puoi vedere tutte le modifiche in un pannello di anteprima live. I cambiamenti vengono aggiornati in tempo reale in modo dinamico.',
          },
          {
            title: 'Indicatore di scansione:',
            text: 'Durante la scelta dei colori, avvisi e indicatori ti guidano se selezioni combinazioni difficili da scansionare.',
          },
        ],
        formatHeaders: {
          srNo: 'N.',
          formats: 'Formati',
          description: 'Descrizione',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Senza perdita, supporto trasparenza' },
          { no: '2', format: 'JPG', description: 'Formato file popolare e universale' },
          { no: '3', format: 'WEBP', description: 'Formato moderno, miglior qualità/dimensione' },
          { no: '4', format: 'SVG', description: 'Grafica vettoriale scalabile' },
          { no: '5', format: 'PDF', description: 'Documento pronto per la stampa' },
        ],
      },
      card3: {
        title: '3. Guida passo dopo passo:',
        step1Intro: 'Per prima cosa seleziona la categoria del codice QR che vuoi generare, ad esempio contatto, mappa, link o testo. Attualmente il nostro generatore offre queste categorie:',
        categories: ['Link / URL', 'Testo', 'WiFi', 'Contatto', 'Gmail', 'Google Maps'],
        step2: 'Dopo aver selezionato la categoria, incolla le informazioni nel campo di testo corrispondente.',
        step3Intro: 'Poi clicca su Generate & Customize per aprire il pannello di personalizzazione. Nel pannello troverai una sotto-navigazione con le seguenti opzioni:',
        options: [
          {
            title: 'Stile e Forma:',
            text: 'In questa sezione puoi cambiare la forma dei moduli quadrati in diversi stili: angoli arrotondati, punti, barre orizzontali, barre verticali, piccoli quadrati e altro ancora.',
          },
          {
            title: 'Colore:',
            text: 'In questa sezione puoi selezionare colori personalizzati di sfondo e primo piano. Per creare un QR in gradiente puoi abilitare il gradiente, applicare un preset dalla libreria integrata oppure crearne uno tuo facilmente. Puoi anche cambiare l’angolo del gradiente lineare. È supportato anche il gradiente radiale. Puoi aggiungere più colori per ottenere un effetto professionale.',
          },
          {
            title: 'Cornici:',
            text: 'Qui puoi scegliere una cornice perfetta per il tuo codice QR. Tutte le cornici si adattano automaticamente al codice. Devi solo selezionare una cornice dalla libreria integrata.',
          },
          {
            title: 'Logo:',
            text: 'Dopo aver scelto la cornice, puoi selezionare un logo che viene adattato automaticamente al centro del codice QR. È supportato anche il caricamento del tuo logo brand personalizzato.',
          },
          {
            title: 'Template:',
            text: 'Se non vuoi selezionare stile, forma, colore e cornice separatamente, puoi applicare template predefiniti al tuo codice QR. Sono disponibili più template premium gratuiti per sempre.',
          },
          {
            title: 'Formato File:',
            text: 'Infine devi selezionare il tipo di file con cui vuoi scaricare il codice QR. Sono supportati vari formati comuni, tra cui PNG, WEBP, SVG e PDF.',
          },
          {
            title: 'Modifica Dati QR:',
            text: 'Puoi anche modificare i dati del QR senza perdere le personalizzazioni selezionate.',
          },
        ],
        finalStep: 'Infine clicca semplicemente sul pulsante di download e il codice QR, esattamente secondo le tue personalizzazioni e nel formato selezionato, verrà scaricato subito senza alcun costo.',
      },
      card4: {
        title: '4. Vantaggi:',
        intro: 'Il codice QR collega il mondo fisico all’esperienza digitale. È il modo più rapido per condividere link, contatti o posizione. Basta scansionare il codice QR per accedere subito alle informazioni. Per questo è molto usato nel business e nel mondo digitale: fa risparmiare tempo ed è altamente funzionale.',
        benefits: [
          {
            title: 'Supporto a vita:',
            text: 'I codici QR funzionano senza scadenza. Quando li scansioni, forniscono subito le informazioni memorizzate. Poiché conservano istruzioni digitali codificate in modo stabile, non perdono i dati nel tempo.',
          },
          {
            title: 'Supporto offline:',
            text: 'Puoi scansionare il codice QR anche quando sei offline. La fotocamera del telefono decodifica il pattern del QR e ti mostra le informazioni memorizzate.',
          },
          {
            title: 'Costo zero:',
            text: 'Poiché questi codici non richiedono reindirizzamenti server o risorse aggiuntive, restano gratuiti per sempre.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Scanner QR Code — Scansiona QR Code da Fotocamera o Immagine | photremium.com',
      desc: 'Scansiona QR code con la fotocamera o caricando un\'immagine. Rileva URL, testo, WiFi e altro.',
      keywords: 'scanner qr code, scansiona qr code, lettore qr, lettore qr code online',
    },
    title: 'Scanner QR Code',
    desc: 'Scansiona QR code con la fotocamera o carica un\'immagine. Veloce, privato e sicuro.',
    generateQrCode: 'Genera QR Code',
    scan: 'Scansiona',
    cameraScanner: 'Scanner Fotocamera',
    uploadImage: 'Carica Immagine',
    pointCamera: 'Punta la fotocamera su un QR code',
    startCamera: 'Avvia Fotocamera',
    loading: 'Caricamento…',
    dropQrImage: 'Rilascia l\'immagine QR code qui',
    toScan: 'per scansionare',
    supportedFormats: 'Supporta JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Ctrl+V per incollare',
    scanFromGallery: 'Scansiona dalla Galleria',
    accessingCamera: 'Accesso alla fotocamera…',
    cameraDenied: 'Accesso fotocamera negato. Consenti l\'accesso e riprova.',
    noCamera: 'Nessuna fotocamera trovata su questo dispositivo.',
    cameraError: 'Impossibile accedere alla fotocamera. Riprova.',
    tryAgain: 'Riprova',
    switchCamera: 'Cambia Fotocamera',
    stop: 'Ferma',
    noQrFound: 'Nessun QR Code Trovato',
    couldNotRead: 'Impossibile leggere l\'immagine',
    scannerFailed: 'Scanner non caricato',
    noQrFoundDesc: 'Nessun QR code rilevato nell\'immagine. Prova un\'altra immagine o usa lo scanner fotocamera.',
    qrScanned: 'QR Code Scansionato!',
    openLink: 'Apri Link',
    copied: 'Copiato!',
    copy: 'Copia',
    share: 'Condividi',
    scanAgain: 'Scansiona di Nuovo',
    network: 'Rete',
    password: 'Password',
    security: 'Sicurezza',
    unknown: 'Sconosciuto',
    blog: {
      tocTitle: 'Contenuti',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Perché usare uno scanner QR code?',
          paragraphs: [
            'Uno scanner QR code è, in pratica, una fotocamera mobile che decodifica le informazioni contenute nel QR code. Ti basta puntare la fotocamera verso il codice: indipendentemente dall’orientamento, leggerà i pattern specifici, rileverà eventuali errori, li correggerà quando necessario e mostrerà le informazioni contenute.',
          ],
          listTitle: 'Tipi di scanner QR code:',
          bullets: [
            'Scanner QR code web-based: puoi scansionare il QR code con scanner online supportati dal browser. Puoi ottenere le informazioni dalla fotocamera o caricando un’immagine. Per redirect automatico e altre funzioni avanzate, puoi visitare https://photremium.com.',
            'Fotocamere mobili: alcuni smartphone moderni hanno uno scanner QR integrato nell’app fotocamera originale. Possono leggere e decodificare le informazioni semplicemente inquadrando il QR code.',
            'App: esistono app dedicate alla scansione dei QR code. Tuttavia, per redirect avanzato e molte altre funzioni, puoi installare l’app gratuitamente da questo link: https://photremium.com.',
            'Dispositivi hardware: esistono anche dispositivi hardware pensati per la scansione dei QR code. Sono molto usati nei grandi centri commerciali per la gestione della cassa.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Perché scegliere il nostro scanner QR code?',
          paragraphs: [
            'Puoi esplorare diverse funzioni avanzate, dal redirect alla copia del contenuto decodificato dal QR code. Nel nostro scanner QR code trovi anche molte altre funzioni utili, come:',
          ],
          bullets: [
            'Velocità elevata: il nostro scanner QR code rende la decodifica estremamente veloce. Basta scansionare il codice e il tool mostra subito le informazioni con opzioni avanzate per copiare testo/link, aprire se rileva un link, o salvare automaticamente se rileva un contatto.',
            'Nessuna installazione: non devi installare app separate per usare il nostro scanner QR code. Puoi usarlo gratuitamente dal browser.',
            'Accesso multipiattaforma: puoi usarlo su qualsiasi dispositivo. Nessuna preoccupazione per versione OS o requisiti extra: è supportato in modo ampio.',
            'Tutti i formati supportati: tutti i formati dati che possono essere contenuti in un QR code sono supportati, inclusi testo semplice, WiFi, URL, contatti, Gmail, Google Maps, ecc.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Guida passo passo:',
          steps: [
            {
              heading: '1. Prima di tutto, scegli un metodo per scansionare il QR code. Ci sono due metodi:',
              subSteps: [
                {
                  heading: 'i. Metodo fotocamera',
                  paragraphs: [
                    'Puoi scansionare il QR code usando la fotocamera del dispositivo anche se usi laptop, PC o qualsiasi dispositivo con una fotocamera semplice. Cliccando su “Avvia fotocamera” comparirà una richiesta di permesso: consenti al sito di usare la fotocamera per la scansione QR. Se hai rifiutato per errore o la richiesta non appare, puoi concedere l’accesso manualmente seguendo questi passaggi:',
                  ],
                  notes: [
                    '➔ Per Chrome (Android / Desktop):',
                    '1. Clicca sui tre puntini',
                    '2. Vai su Impostazioni',
                    '3. (Salta questo passaggio su Android) Privacy e sicurezza',
                    '4. Clicca su Impostazioni sito',
                    '5. Poi, nella sezione permessi, clicca su Fotocamera',
                    '6. Trova l’URL del nostro sito: https://photremium.com/qr-code-scanner',
                    '7. Imposta la fotocamera su Consenti nel menu a tendina.',
                    '➔ Per Safari (iPhone / iOS):',
                    '1. Tocca l’icona AA o Impostazioni sito nella barra indirizzi.',
                    '2. Seleziona Website Settings.',
                    '3. Tocca Camera e scegli Allow.',
                    '4. Se è ancora bloccata: vai in Impostazioni iPhone > Safari > Camera e imposta Ask o Allow.',
                  ],
                },
                {
                  heading: 'ii. Metodo galleria',
                  paragraphs: [
                    'Puoi caricare l’immagine di un QR code per accedere alle sue informazioni. Clicca su “Scansiona da Galleria” e si aprirà l’esplora file. Poi seleziona l’immagine del QR code. Sono supportati tutti i formati immagine come .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz e .xbm, ecc.',
                  ],
                },
              ],
            },
            {
              heading: '2. Quando selezioni il QR code, tutte le informazioni vengono mostrate; puoi copiare, condividere o aprire il link se rilevato. Puoi anche scansionare di nuovo se vuoi.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Vantaggi dello scanner QR code:.',
          paragraphs: [
            'Lo scanner QR code offre diversi vantaggi nel mondo digitale. Rende pagamenti, verifiche e accesso alle informazioni facili e veloci anche in modalità offline.',
          ],
          bullets: [
            'Accesso istantaneo alle informazioni: la scansione del QR code fornisce informazioni in pochi millisecondi. Decodifica i pattern, rileva e corregge errori velocemente, offrendo un’esperienza utente molto rapida.',
            'Comunicazione fluida: in questa era è fondamentale una comunicazione rapida e sicura per piccole informazioni come dettagli bancari e dati prodotto. Lo scanner QR aiuta in questo: i pagamenti avvengono tramite scansione QR. Anche Google usa la verifica via QR del telefono durante la creazione di un nuovo account su laptop.',
            'Biglietti elettronici: in stazioni bus, ferroviarie o aeroporti, puoi verificare i biglietti senza lunghe code. Inoltre, i QR scanner installati in più punti negli aeroporti riducono le attese. Questo riduce anche il fabbisogno di personale, con risparmio di budget per le compagnie aeree.',
            'Autenticazione prodotto: i brand premium installano un QR code sul prodotto. Il cliente può scansionarlo per verificarne l’autenticità.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Sfoca Volti — Sfoca Volti nelle Immagini Online | photremium.com',
      uploadDesc: 'Sfoca automaticamente i volti nelle immagini con rilevamento AI. Scegli intensità, forma o emoji.',
      uploadKeywords: 'sfoca volti, sfocatura viso, rilevamento viso, privacy immagini',
      workspaceTitle: 'Sfocatura Volti — photremium.com Strumento Sfocatura',
      workspaceDesc: 'Sfoca automaticamente i volti nelle immagini. 100% gratuito.',
      workspaceKeywords: 'sfoca volti, sfocatura viso',
    },
    title: 'Sfoca Volti',
    desc: 'Rileva e sfoca automaticamente i volti per la privacy. Scegli intensità, forma o emoji.',
    toBlurFaces: 'per sfocare i volti',
    autoDetection: 'Rilevamento Automatico',
    autoDetectionDesc: 'Il rilevamento AI trova tutti i volti istantaneamente',
    customBlur: 'Sfocatura Personalizzata',
    customBlurDesc: 'Regola intensità, forma e stile della sfocatura',
    private100: '100% Privato',
    private100Desc: 'Tutta l\'elaborazione avviene localmente nel tuo browser',
    blurTools: 'Strumenti Sfocatura',
    faces: 'Volti',
    faceDetection: 'Rilevamento Volti',
    detecting: 'Rilevamento in corso...',
    autoDetectFaces: 'Rileva Volti Automaticamente',
    exitManualMode: 'Esci dalla Modalità Manuale',
    manualSelect: 'Selezione Manuale',
    nFaceRegions: '{n} area/e volto trovata/e',
    noFacesDetected: 'Nessun volto rilevato — usa la modalità manuale',
    manualHint: 'Clicca e trascina sull\'immagine per disegnare un rettangolo sull\'area da sfocare.',
    blurType: 'Tipo Sfocatura',
    blur: 'Sfocatura',
    emoji: 'Emoji',
    blurIntensity: 'Intensità Sfocatura',
    strength: 'Forza',
    blurShape: 'Forma Sfocatura',
    rectangle: 'Rettangolo',
    ellipse: 'Ellisse',
    circle: 'Cerchio',
    chooseEmoji: 'Scegli Emoji',
    blurRegionsN: 'Aree Sfocatura ({n})',
    faceN: 'Volto {n}',
    manualRegionN: 'Area Manuale {n}',
    manualN: 'Manuale {n}',
    clearAllRegions: 'Cancella Tutte le Aree',
    processingDots: 'Elaborazione...',
    downloadBlurred: 'Scarica Immagine Sfocata',
    downloadNImages: 'Scarica {n} Immagini',
    downloadDialogTitle: 'Non tutte le immagini modificate',
    downloadDialogText: 'Hai modificato {edited} su {total} immagini.',
    downloadAll: 'Scarica Tutti',
    removeRegion: 'Rimuovi area',
    region: 'Area',
    notAllEdited: 'Non tutte le immagini sono state modificate',
    editedXofY: 'Hai modificato {edited} su {total} immagini.',
    nextImage: 'Immagine Successiva',
  },

  faqData: {
    imageConverter: [
      { q: 'Quali formati immagine sono supportati per la conversione?', a: 'Supportiamo JPG, PNG, WEBP, SVG, GIF, BMP, ICO e TIFF. Puoi convertire tra qualsiasi di questi formati istantaneamente nel tuo browser.' },
      { q: 'La qualità dell\'immagine verrà influenzata durante la conversione?', a: 'Per formati senza perdita come PNG, la qualità è completamente preservata. Per formati con perdita come JPG e WEBP, utilizziamo impostazioni ottimizzate per mantenere la migliore qualità visiva.' },
      { q: 'Esiste un limite di dimensione o quantità dei file?', a: 'Non ci sono limiti fissi — puoi caricare più immagini contemporaneamente. Poiché tutto viene eseguito localmente nel browser, la velocità dipende dal tuo dispositivo.' },
      { q: 'I miei dati sono al sicuro? Le immagini vengono caricate su un server?', a: 'Assolutamente sì. Tutta l\'elaborazione avviene nel tuo browser. Le tue immagini non lasciano mai il tuo dispositivo.' },
      { q: 'Posso convertire immagini PNG trasparenti in JPG?', a: 'Sì. Poiché JPG non supporta la trasparenza, le aree trasparenti verranno riempite con uno sfondo bianco.' },
    ],
    imageCompressor: [
      { q: 'Comprimere un\'immagine ne riduce la qualità?', a: 'No, comprimere un\'immagine non ne riduce la qualità finché resti entro i limiti consigliati. Gli indicatori ti aiutano a capire il risultato: i. Compressione 1%–40%: indicatore verde con messaggio “Buona qualità”. ii. Compressione 41%–60%: indicatore giallo con messaggio “Qualità normale”. Questa fascia è generalmente consigliata. iii. Compressione 61%–100%: il sistema mostra un avviso rosso “Qualità bassa”, e la perdita può diventare visibile.' },
      { q: 'Quali formati immagine sono supportati per la compressione?', a: 'Il nostro strumento supporta tutti i seguenti formati:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Posso comprimere più immagini contemporaneamente?', a: 'Sì, assolutamente. Puoi comprimere più immagini insieme (anche 100+) se il tuo dispositivo lo consente. Poiché la compressione usa le risorse del dispositivo, un laptop, PC o telefono più performante offrirà risultati migliori. Se hai un dispositivo meno potente, puoi comprimere in più batch: lo strumento resta gratuito anche in questo caso.' },
      { q: 'Memorizzate o caricate le mie immagini sui vostri server?', a: 'No, non carichiamo né memorizziamo mai le tue immagini sui nostri server. Tutte le immagini vengono compresse localmente nel browser. I tuoi file non lasciano mai il dispositivo, quindi puoi comprimere anche immagini personali o private in tranquillità.' },
      { q: 'Questo strumento di compressione immagini è gratuito?', a: 'Sì, il nostro compressore immagini è completamente gratuito per sempre. Non ti chiederemo mai alcun pagamento. Non ci sono costi nascosti. Tutte le funzioni, inclusa la compressione multipla, sono gratuite.' },
    ],
    cropImage: [
      { q: 'Il ritaglio delle immagini riduce la qualità?', a: 'No, ritagliare un’immagine non influisce affatto sulla sua qualità visiva. Il ritaglio rimuove solo la parte indesiderata dell’immagine. Non modifica mai i pixel della parte che rimane dopo il ritaglio. Quindi puoi ritagliare le tue immagini mantenendo la qualità originale senza alcuna perdita di pixel.' },
      { q: 'Quali formati immagine sono supportati dal ritagliatore?', a: 'Puoi selezionare immagini in qualsiasi formato perché il nostro ritagliatore supporta quasi tutti i formati immagine. Sono elencati qui sotto:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Le mie immagini vengono caricate sui vostri server?', a: 'No, tutta l’elaborazione avviene nel tuo browser locale. Le tue immagini non vengono mai caricate sui nostri server perché non lasciano mai il tuo dispositivo. Quindi puoi ritagliare immagini personali con il nostro strumento senza alcun rischio.' },
      { q: 'Posso ritagliare più immagini contemporaneamente?', a: 'Sì, puoi ritagliare più immagini (anche 100+) in una volta sola se il tuo sistema lo supporta. Poiché il ritaglio usa le risorse del dispositivo, con un laptop, PC o telefono ad alte prestazioni puoi ritagliare molte immagini insieme. Se hai un dispositivo meno potente, puoi ritagliare a lotti perché lo strumento è gratuito anche in caso di uso intenso.' },
      { q: 'Questo ritagliatore di immagini è gratuito?', a: 'Sì, questo ritagliatore è completamente gratuito per sempre. Puoi accedervi ovunque, in qualsiasi momento e da qualsiasi dispositivo. Avrai un design responsivo su tutti i dispositivi e non ti verrà mai chiesto di pagare funzioni premium. Tutte le funzioni sono totalmente gratuite, senza costi nascosti.' },
    ],
    resizeImage: [
      { q: 'Posso ridimensionare più immagini contemporaneamente?', a: 'Assolutamente, il nostro strumento di ridimensionamento consente di ridimensionare più immagini in una sola volta. Ti basta caricare tutte le immagini supportate dal tuo dispositivo e il nostro motore IA le ridimensionerà insieme. Se hai un dispositivo meno potente, prova a ridimensionare in più batch per evitare rallentamenti. Il ridimensionamento usa le risorse del dispositivo per evitare upload a server e proteggere la privacy.' },
      { q: 'Questo strumento di ridimensionamento è gratuito?', a: 'Sì, questo strumento è gratuito per sempre. Non ti verrà mai richiesto un abbonamento a pagamento per sbloccare funzionalità premium. Non ci sono costi nascosti per scaricare le immagini ridimensionate.' },
      { q: 'Ridimensionare un’immagine ne riduce la qualità?', a: '✅Decrease Size (downscale): Ridurre la dimensione dell’immagine non riduce la qualità visiva. Anzi, l’immagine ridimensionata può apparire più nitida dell’originale. Quindi ridurre a dimensioni più piccole non comporta perdita di qualità.\n❌Increase Size (upscale): Aumentare la dimensione oltre quella originale può influire sulla qualità visiva. La gravità dipende da quanto viene aumentata. Più aumenti, più la qualità cala.' },
      { q: 'Questo strumento di ridimensionamento è sicuro da usare?', a: 'Sì, il nostro ridimensionatore è totalmente sicuro, soprattutto per immagini personali e private, perché tutte le immagini vengono elaborate localmente. Nessun dato lascia il tuo dispositivo durante l’elaborazione. Quindi puoi ridimensionare immagini personali senza rischi.' },
      { q: 'Quali formati immagine sono supportati?', a: 'Tutti i formati immagine sono supportati dal nostro strumento. Puoi selezionare immagini in questi formati:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Come funziona la rimozione dello sfondo?', a: 'Utilizziamo un modello AI avanzato che gira nel tuo browser per rilevare il soggetto e separarlo dallo sfondo, producendo un PNG trasparente.' },
      { q: 'Funziona con sfondi complessi?', a: 'Sì. Il modello AI gestisce una grande varietà di scene. I risultati migliori si ottengono con un contrasto netto tra soggetto e sfondo.' },
      { q: 'Posso rimuovere gli sfondi da più immagini contemporaneamente?', a: 'Sì. Carica più immagini e il tool le elaborerà in sequenza. Puoi scaricarle tutte come ZIP.' },
      { q: 'Qual è il formato di output?', a: 'L\'output è sempre un file PNG con sfondo trasparente.' },
      { q: 'Le mie immagini vengono inviate a un server?', a: 'No. Il modello AI gira interamente nel tuo browser usando WebAssembly. Le tue immagini rimangono sul dispositivo.' },
    ],
    watermarkImage: [
      { q: '1. Lo strumento filigrana di Photremium è completamente gratuito?', a: 'Sì, lo strumento di filigrana su photremium.com/watermark-image è gratuito, senza account e senza abbonamento. Puoi filigranare singole immagini o interi batch senza paywall, senza registrazioni obbligatorie e senza limiti di download. Lo strumento è sostenuto dal valore complessivo della piattaforma Photremium, non dal blocco delle funzioni principali.' },
      { q: '2. Quante immagini posso filigranare in una volta sola?', a: 'Lo strumento supporta la filigranatura in batch di più immagini. Puoi trascinare un’intera cartella nella zona di upload o selezionare decine di file con Ctrl+Click. La barra di miniature a sinistra mostra tutti i file, e cliccando "Watermark & Download All" lo strumento renderizza ogni immagine e le impacchetta in un ZIP (o le scarica come file separati — a tua scelta). In pratica, il limite è la memoria disponibile del tuo dispositivo, non un limite artificiale.' },
      { q: '3. Quali formati sono supportati per input e output?', a: 'L’input accetta i formati gestiti dal File API del browser — tipicamente JPEG, JPG, PNG, WEBP, GIF (statico), BMP e SVG. L’output mantiene il formato originale: se carichi un PNG, ottieni un PNG; se carichi un JPEG, ottieni un JPEG con qualità 0.95. Questo evita la conversione accidentale di PNG lossless in JPG lossy.' },
      { q: '4. La filigrana avrà lo stesso aspetto su immagini con risoluzioni diverse?', a: 'Sì, grazie al motore di riposizionamento proporzionale. Quando lavori su un batch con dimensioni diverse, la filigrana viene creata sull’immagine di riferimento (quella selezionata nel canvas). In fase di export, il motore calcola la posizione di ogni layer come offset frazionale rispetto al centro dell’immagine e applica la stessa proporzione a ogni immagine target. Anche la dimensione viene scalata in modo proporzionale usando il rapporto più piccolo (larghezza vs altezza) per evitare sforamenti. Risultato: filigrana con posizione e dimensione relative coerenti su tutto il batch.' },
      { q: '5. Posso usare il mio logo o una firma come filigrana al posto del testo?', a: 'Assolutamente. Il pulsante "Add Image" nel pannello destro ti consente di caricare qualsiasi immagine come layer di filigrana. I PNG con sfondo trasparente funzionano al meglio — la trasparenza viene mantenuta e si vede solo il logo. Puoi ridimensionare tramite gli angoli (con rapporto bloccato), ruotare, ribaltare, regolare l’opacità e persino aggiungere un bordo o angoli arrotondati. Molti utenti preparano una versione trasparente del logo appositamente per la filigranatura.' },
      { q: '6. Come rendo la filigrana trasparente o semi-trasparente?', a: 'Seleziona il layer di filigrana sul canvas. Nella toolbar superiore trovi il controllo dell’opacità in percentuale — puoi digitare un valore o trascinare. Per una filigrana discreta e professionale, 30–50% è in genere ideale; per una più evidente, 70–80% funziona bene. Puoi anche confrontare rapidamente attivando/disattivando la visibilità nel layer manager (icona dell’occhio).' },
      { q: '7. Posso aggiungere più filigrane alla stessa immagine?', a: 'Sì — il sistema di layer supporta un numero illimitato di filigrane, ciascuna con impostazioni indipendenti. Puoi avere un testo di copyright in basso a destra, un logo in alto a sinistra e un overlay "SAMPLE" in tiling contemporaneamente. Ogni layer ha opacità, rotazione, posizione, dimensione e stile propri. Il layer manager le organizza e consente di attivare/disattivare senza eliminare per testare varianti.' },
      { q: '8. A cosa serve il tiling e quando dovrei usarlo?', a: 'Il tiling ripete la filigrana in una griglia su tutta l’immagine. Grid 2×2 posiziona quattro copie; Grid 3×3 ne posiziona nove. Il controllo dello spacing regola la distanza tra le copie. È utile quando vuoi rendere l’immagine inutilizzabile senza autorizzazione — una filigrana in un angolo può essere facilmente ritagliata, mentre un pattern completo è difficile da rimuovere senza rovinare l’immagine. È una tecnica comune per anteprime contrattuali, bozze per approvazione o contenuti prima del pagamento.' },
      { q: '9. Funziona su telefoni e tablet?', a: 'Sì, lo strumento è completamente responsive e progettato per il mobile. Sotto i 900 px, il layout a tre pannelli diventa a pile: la strip di miniature diventa una riga orizzontale, il canvas resta al centro e il pannello impostazioni appare come bottom sheet tramite un pulsante a ingranaggio flottante. Tutte le interazioni — trascinamento, maniglie di ridimensionamento, rotazione — sono touch-friendly. Le maniglie sono leggermente più grandi su mobile (16×16 px) per facilitare il tocco.' },
      { q: '10. I miei dati sono privati? Le foto vengono caricate su un server?', a: 'Le tue immagini non lasciano mai il dispositivo. L’intero flusso — caricamento, rendering, export finale — avviene nel browser usando JavaScript e HTML5 Canvas API. Il File API crea una rappresentazione in memoria, i layer vengono disegnati su una canvas off-screen e, al download, i pixel vengono convertiti in Blob per un salvataggio locale. Non esistono richieste di rete che includano i tuoi dati immagine. Inoltre, lo strumento include un avviso di uscita: se provi a chiudere la pagina con immagini caricate, il browser chiede conferma per evitare perdite accidentali.' },
    ],
    qrCodeGenerator: [
      { q: 'Questo QR code scade?', a: 'No, questi QR code non scadono e garantiscono supporto a vita. Poiché memorizzano istruzioni codificate in modo fisso sotto forma di bit all\'interno di riquadri quadrati, le informazioni contenute non possono essere modificate o rimosse. Puoi accedere alle informazioni nel codice semplicemente scansionandolo con qualsiasi fotocamera anche dopo anni.' },
      { q: 'Perché il mio QR code non viene scansionato?', a: 'Il tuo QR code potrebbe non essere scansionato per i seguenti motivi: i. Basso contrasto: se scegli colori di sfondo e primo piano troppo simili, la visibilità del QR code diminuisce e la scansione può fallire. Il nostro strumento ti guida durante la personalizzazione segnalando basso contrasto o altri problemi di scansione. ii. Dati troppo grandi: se generi un QR code per un testo molto lungo, il codice diventa troppo complesso e difficile da leggere. Un validatore della lunghezza del testo ti aiuta a mantenere una lunghezza ottimale. iii. Stampa sfocata: assicurati di scaricare il QR code in un formato ad alta risoluzione come PNG o SVG, già supportati dal nostro strumento.' },
      { q: 'Posso aggiungere un logo nel QR code?', a: 'Assolutamente sì, puoi aggiungere un logo personalizzato oppure sceglierne uno dalla libreria logo integrata per il tuo QR code. Il logo selezionato verrà regolato automaticamente al centro del QR code.' },
      { q: 'Come posso scansionare il QR code?', a: 'Puoi scansionare il QR code usando la fotocamera del tuo telefono. Per il reindirizzamento automatico al link e molte altre funzioni avanzate, puoi anche usare gratuitamente il nostro scanner QR su https://photremium.com/qr-code-scanner.' },
      { q: 'Quanti QR code posso generare gratis?', a: 'ILLIMITATI! Puoi generare più QR code gratuitamente. Tutte le funzionalità, personalizzazioni e template sono gratis per sempre per tutti. Non è necessario alcun abbonamento per usare funzionalità premium.' },
      { q: 'Devo fare login/registrarmi per generare un QR code?', a: 'No, basta inserire il testo, generare il QR code e scaricarlo dopo la personalizzazione. Non serve fare login o registrarsi, perché tutte le funzioni sono disponibili completamente gratis.' },
    ],
    qrCodeScanner: [
      { q: 'Posso scansionare QR code da immagini salvate e screenshot?', a: '**Sì**, puoi scansionare un QR code da immagini salvate o screenshot. Il nostro scanner QR code https://photremium.com/qr-code-scanner ti permette di scansionare dalla galleria. Ti basta selezionare l’immagine e otterrai tutte le informazioni decodificate da quel QR code.' },
      { q: 'Devo installare un’app per usare lo scanner QR code?', a: '**No**, il nostro scanner QR code web-based ti permette di scansionare senza installare app. Puoi accedere gratuitamente al nostro scanner avanzato da qualsiasi dispositivo.' },
      { q: 'Perché lo scanner non riconosce il QR code?', a: 'Il QR code potrebbe non essere letto per uno di questi motivi: i. Luce insufficiente: scansionare con poca luce può causare problemi. Attiva la torcia e aumenta la luminosità se stai scansionando da uno schermo. ii. Distanza: una distanza non corretta può creare difficoltà. La distanza ottimale è circa 10 pollici (25cm). iii. Lente sporca: il QR può non essere letto anche per lente sporca. Pulisci la lente prima della scansione. “Vedi una griglia a riquadro nello scanner? Inserisci il QR dentro il riquadro per scansionarlo correttamente.”' },
      { q: 'Questo strumento scansiona QR code invertiti o colorati?', a: '**Sì**, puoi scansionare QR in qualsiasi colore o orientamento. Tuttavia, se il contrasto tra sfondo e primo piano è basso, la scansione può risultare più difficile.' },
      { q: 'Questo strumento è gratuito?', a: '**Sì**, questo strumento è totalmente gratuito. Puoi scansionare QR code illimitati gratis per sempre.' },
    ],
    faceBlur: [
      { q: 'Come funziona il rilevamento dei volti?', a: 'Utilizziamo un modello AI che gira nel tuo browser. Identifica i volti nell\'immagine così puoi applicare l\'effetto sfocatura.' },
      { q: 'Posso scegliere quali volti sfocare?', a: 'Sì. Dopo il rilevamento, ogni area del volto viene evidenziata e puoi selezionare quali sfocare.' },
      { q: 'Quali stili di sfocatura sono disponibili?', a: 'Puoi scegliere tra sfocatura gaussiana, pixelazione o overlay a colore solido. L\'intensità di ogni effetto è regolabile.' },
      { q: 'Posso sfocare volti in più immagini contemporaneamente?', a: 'Sì. Carica più immagini, configura le aree di sfocatura e scarica tutte le immagini elaborate.' },
      { q: 'Le mie foto vengono inviate a un server remoto?', a: 'No. Il modello AI gira nel browser usando WebAssembly. Le tue foto non vengono mai caricate su server.' },
    ],
    photoEditor: [
      { q: 'Quali funzionalità di editing sono disponibili?', a: 'Puoi regolare luminosità, contrasto, saturazione, applicare filtri, aggiungere testo, overlay, cornici, adesivi e molto altro — tutto nel browser.' },
      { q: 'Posso annullare e ripetere le modifiche?', a: 'Sì. L\'editor supporta la cronologia completa di annullamento/ripetizione.' },
      { q: 'Quali formati di file posso modificare ed esportare?', a: 'Puoi modificare JPG, PNG, WEBP e altri formati comuni. L\'immagine modificata può essere esportata nel formato preferito.' },
      { q: 'L\'editor funziona su mobile?', a: 'Sì. L\'editor è completamente responsive e touch-friendly.' },
      { q: 'Le mie immagini vengono archiviate sui vostri server?', a: 'No. Tutta l\'elaborazione avviene localmente. Le tue immagini non lasciano mai il dispositivo.' },
    ],
  },
};

export default it;
